/*
 * @Author: liyxt
 * @Date: 2019-08-06 16:13:32
 * @LastEditors: bbqin
 * @LastEditTime: 2023-04-28 15:06:58
 * @Description: file content
 */
/* eslint-disable max-lines */
/* eslint-disable no-loop-func */
/* eslint-disable max-lines */
/* eslint-disable import/named */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// eslint-disable-next-line max-lines
import React, { cloneElement } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
// 第三方库
import { HotKeys } from 'react-hotkeys';
// base
import FormControl from '../-FormControl';
import Col from '../Col';
import Dropdown from '../Dropdown';
import Textarea from '../TextArea';

// api
import {
    toast,
    getSysFieldid,
    ajax,
    getGlobalStorage,
    ViewModel,
    microAppUtil,
} from '@platform/api';
import {
    calculateResizeContainerHeight,
    compare,
    compareArr,
    perceptionDropDownShow,
    perceptionInputContainerClass,
    handleArrowKeyDown,
} from './utils';
import DropDownOfRefer from './components/DropDownOfRefer';
// import DropDownTableRefer from './components/DropDownTableRefer';
import DropDownTableRefer from './components/DropDownTableOfRefer';

import TipsTitle from './components/TipsTitle';
// 参照方法类
import Methods from './Methods';
import { throttle, debounce, isArray, cloneDeep } from 'lodash';
// 多语资源
import { getMultiLang } from '@platform/api';
import { findParentTd } from '@platform/api';

// 组件
class BaseRefer extends Methods {
    constructor(props) {
        super(props);
        this.state = {
            referVal: '', // 输入框的值
            tableData: [
                {
                    rows: [],
                    page: {
                        pageIndex: 0,
                        pageSize: props.pageSize,
                        totalPage: 1,
                    },
                },
            ], // 参照的数据
            treeData: [props.rootNode], // 左树的值
            currentLevel: 0, // 当前是第几级
            dropDownList: {
                page: {
                    pageIndex: 0,
                    pageSize: props.pageSize,
                    totalPage: 1,
                },
                rows: [],
            }, // 下拉搜索和历史记录
            dropDownShow: false, // 搜索和历史记录下拉是否显示
            isShow: false, // 参照下拉和弹窗是否显示
            loading: false, // loading是否显示
            selectedValues: new Map(), // 已选的数据
            isSelectedShow: false, // 是否显示已选择
            group: { undefined: [props.rootNode] }, // 分组树数据
            virtualNodeSet: new Set(),
            jsonInsideRefer: {}, // 参照多语
            treeDataWithChildren: [], // 树形的数据结构
            historySelectionVisible: false, // 参照在表格中渲染时是否显示历史记录, 在表格中用ctrl键控制历史记录是否打开，因此需要多一个状态去记录
            searchHasMoreData: false,
            snapValue: [],
            showHistoryFlag: false, //控制下拉历史记录是否已选择完
            selectedDeleteFlag: false, //控制已选项删除
            deleteSelectedData: [],
            deleteHistoryData: [],
            HistoryDeleteFlag: false,
            deleteSearchData: [],
            searchDeleteFlag: false,
            showDropDownTable: false,
            unblurfalg: false,
            collectUsualData: new Map(),
            cancelSearchStatus: false,
            addButtonDropDown: [],
            pagPageInfo: {},
            usePagaPageInfo: false,
        };
        this.interval = 0;
        this._value = new Map(); // 实际已选值
        this.startIndex = 0;
        this.endIndex = 0;
        this.originGroup = {};
        this.originKeyMap = {};
        this.scrollContainer = document.querySelector('html'); // YBP-RIA-BUG-14393 body和#app上都没滚动条，滚动条默认在html上
        // this.scrollContainer = microAppUtil.getPopContainer();
        //this.defaultBody = microAppUtil.getDocument();
        // this.homePageContainer = null;
    }

    componentWillMount() {
        let { autoFocus } = this.props;
        if (autoFocus) {
            this.autoFocus = true;
            this.focusFlag = true;
        }

        this.propsToState(this.props);

        let callback = jsonInsideRefer => {
            this.setState({ jsonInsideRefer });
        };
        // moduleId为所需加载json文件夹名称前缀
        getMultiLang({ moduleId: 'containers_refer', callback });
    }

    componentDidMount() {
        let { autoShow, refType, queryGridUrl, onFocus, isShowUsual } =
            this.props;
        let { collectUsualData } = this.state;
        if (autoShow && typeof this.show === 'function') {
            if (!queryGridUrl && refType === 'grid') {
                this.delayAutoShow = true;
            } else {
                setTimeout(() => {
                    this.beforeEvent(onFocus, this.show, {});
                }, 299);
            }
        }

        // if(this.refer && this.refer.matches('.nc-workbench-container .refer-wrapper')){
        //     this.homePageContainer = document.querySelector('.nc-workbench-container');
        // }

        this.lifecycleStatus = 'mount';
        document.addEventListener('keydown', this.handleKeyDown);
        document.addEventListener('keyup', this.handleKeyUp);
        document.addEventListener('mousemove', this.handleMouseMove);
        // document.addEventListener('click', this.handleMouseClick);
        window.addEventListener('blur', this.handleWindowBlur);
        window.addEventListener('focus', this.handleWindowFocus);

        // document.addEventListener('mousemove', (event) => {
        //     // console.log(event.target);
        //     if (event.target.nodeType !== 1) {
        //         return;
        //     }
        //     this.cursorStyle = window
        //         .getComputedStyle(event.target)
        //         .getPropertyValue('cursor');
        //     // console.log('Cursor style: ' + this.cursorStyle);
        // });

        // if (isShowUsual) {
        //     this.loadUsualData().then((data) => {
        //         if (data.rows.length) {
        //             // 有常用--更新下拉面板常用数据
        //             data.rows.forEach((e) => {
        //                 collectUsualData.set(e.refpk, e);
        //             });

        //             this.setState({ collectUsualData });
        //         }
        //     });
        // }
    }

    componentWillReceiveProps(nextProps) {
        this.propsToState(nextProps, this.props);
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevProps || !prevState) {
            return;
        }
        if (prevState.isShow === false && this.state.isShow === true) {
            // 打开
            calculateResizeContainerHeight(this.dragContainer);
            !this.hasOwnProperty('prevOverFlow') &&
                (this.prevOverFlow = this.scrollContainer?.style?.overflow || '');
            this.scrollContainer.style.overflow = 'hidden';
            //修正下zIndex
            let { zIndex } = prevProps;
            let topZIndex = ViewModel.getData('TOPZINDEX');
            if (topZIndex > zIndex) {
                zIndex = topZIndex + 1;
            }
            ViewModel.setData('TOPZINDEX', zIndex);
            this.popWindowzIndex = zIndex;
        } else if (prevState.isShow === true && this.state.isShow === false) {
            // 关闭
            if (this.hasOwnProperty('prevOverFlow')) {
                this.scrollContainer.style.overflow = this.prevOverFlow;
                delete this.prevOverFlow;
            }
        }

        let { idKey, rootNode, queryGridUrl, onFocus, loadConfig, addButtons } =
            this.props;
        let { expandedKeys, group, treeData } = this.state;

        // 根节点改变
        let rootId = rootNode?.[idKey] ?? '',
            prevRootId = prevProps.rootNode?.[prevProps.idKey] ?? '',
            rootName = this.getDisplayOrValue(rootNode, 'display') ?? '',
            prevRootName =
                this.getDisplayOrValue(
                    prevProps.rootNode,
                    'display',
                    prevProps,
                ) ?? '';

        if (prevRootId !== rootId || rootName !== prevRootName) {
            treeData = [rootNode];
            if (Array.isArray(expandedKeys)) {
                let i = expandedKeys.findIndex(e => e === prevRootId);
                expandedKeys.splice(i, 1, rootId);
            } else {
                expandedKeys = [rootId];
            }
            group = { undefined: [rootNode] };

            rootNode && (rootNode.refpk = rootNode.refpk || rootNode[idKey]);

            this.setState({
                treeData,
                expandedKeys,
                group,
            });
        }

        if (
            prevProps.queryGridUrl !== queryGridUrl ||
            prevProps.loadConfig !== loadConfig
        ) {
            if (this.delayAutoShow) {
                this.delayAutoShow = false;
                this.beforeEvent(onFocus, this.show, {});
            } else if (this.delayShow) {
                this.delayShow = false;
                this.show();
            }
        }
        if (prevProps.addButtons.length !== addButtons.length) {
            this.checkAddButtons();
        }
    }

    componentWillUnmount() {
        delete this.referInput;
        delete this.referContainer;
        delete this.hiddenInput;
        delete this.hotKeyElement;
        document.removeEventListener('keydown', this.handleKeyDown);
        document.removeEventListener('keyup', this.handleKeyUp);
        document.removeEventListener('mousemove', this.handleMouseMove);
        // document.removeEventListener('click', this.handleMouseClick);
        window.removeEventListener('blur', this.handleWindowBlur);
        window.removeEventListener('focus', this.handleWindowFocus);

        if (this.hasOwnProperty('prevOverFlow')) {
            this.scrollContainer.style.overflow = this.prevOverFlow;
            delete this.prevOverFlow;
        }
    }

    handleKeyDown = e => {
        this.shiftKey = e.shiftKey;
        this.ctrlKey = e.ctrlKey;
        this.cursorStyle = 'auto';
    };

    handleKeyUp = () => {
        this.shiftKey = false;
        this.ctrlKey = false;
        this.cursorStyle = 'auto';
    };

    handleMouseMove = event => {
        if (event.target.nodeType !== 1) {
            return;
        }
        this.lastMoveTarget = event.target;
        this.cursorStyle = window
            .getComputedStyle(event.target)
            .getPropertyValue('cursor');
        // console.log('Cursor style: ' + this.cursorStyle);
        if (
            (event.target &&
                event.target.offsetParent &&
                event.target.offsetParent.className &&
                (event.target.offsetParent.className.includes(
                    'js-resize-container',
                ) ||
                    event.target.offsetParent.className.includes(
                        'wui-modal-resizbox',
                    ))) ||
            (event.target &&
                event.target.offsetParent &&
                event.target.offsetParent.offsetParent &&
                event.target.offsetParent.offsetParent.className &&
                (event.target.offsetParent.offsetParent.className.includes(
                    'js-resize-container',
                ) ||
                    event.target.offsetParent.offsetParent.className.includes(
                        'wui-modal-resizbox',
                    )))
        ) {
            this.cursorStyle = 'auto';
        }
    };

    // 窗口失焦标记：客户用快捷键切到其他应用查看数据时，下拉面板不应收起
    handleWindowBlur = () => {
        this.windowBlurred = true;
    };

    handleWindowFocus = () => {
        this.windowBlurred = false;
    };

    // handleMouseClick = (event) => {
    //     if (event.target.nodeType !== 1) {
    //         return;
    //     }
    //     this.cursorStyle = window
    //         .getComputedStyle(event.target)
    //         .getPropertyValue('cursor');
    //     // console.log('Cursor style: ' + this.cursorStyle);
    //     if (
    //         event.target &&
    //         event.target.offsetParent &&
    //         event.target.offsetParent.className &&
    //         event.target.offsetParent.className.includes('js-resize-container')
    //     ) {
    //         if (this.cursorStyle === 'col-resize') {
    //             this.cursorStyle = 'auto';
    //         }
    //     }
    // };

    handleHideDropTable = () => {
        this.setState({ showDropDownTable: false }, () => {
            // 查全部数据
            this.close(true);
        });
    };
    handleOnlyHideDropTable = () => {
        this.setState({ showDropDownTable: false });
    };

    handleLoadUsual = () => {
        let { collectUsualData } = this.state;
        // if (this.props.isShowUsual) {
        //     this.loadUsualData().then((data) => {
        //         if (data.rows.length) {
        //             // 有常用--更新下拉面板常用数据
        //             data.rows.forEach((e) => {
        //                 collectUsualData.set(e.refpk, e);
        //             });

        //             this.setState({ collectUsualData });
        //         }
        //     });
        // }
        // this.setState({
        //     cancelSearchStatus: true,
        // });
    };

    //    从localStorage中取下拉面板页签值
    getDropActiveKey = props => {
        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA'),
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl } = props || this.props,
            configKey = queryGridUrl + queryTreeUrl + userId;

        let a = getGlobalStorage('localStorage', 'DropActiveKey');
        let b = getGlobalStorage('localStorage', 'DropActiveKey') || '{}';
        let c = JSON.parse(b);
        // console.log(getGlobalStorage('localStorage', 'DropActiveKey'));
        return c[configKey] || '';
        // return (
        //     JSON.parse(
        //         getGlobalStorage('localStorage', 'DropActiveKey') || '{}'
        //     )[configKey] || ''
        // );
    };

    // handleInputClick时存入列宽度设置
    pushAdjustColumnConfigWidth = config => {
        // [{name: ['编码', '名称'], code: ['refcode', 'refname']}]
        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA'),
        );
        let width;
        if (this.referContainer && this.referContainer.offsetWidth) {
            width = this.referContainer.offsetWidth;
        }
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl } = this.props,
            configKey = queryGridUrl + queryTreeUrl + userId,
            ColumnConfigWidth = JSON.parse(
                getGlobalStorage('localStorage', 'ColumnConfigWidth') || '{}',
            );

        ColumnConfigWidth[configKey] = config;
        this.setStorage('ColumnConfigWidth', JSON.stringify(ColumnConfigWidth));
    };

    // 从localStorage中取下拉面板列宽度设置
    getColumnConfigWidthBase = props => {
        let width;
        if (this.referContainer && this.referContainer.offsetWidth) {
            width = this.referContainer.offsetWidth;
        }

        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA'),
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl } = props || this.props,
            configKey = queryGridUrl + queryTreeUrl + userId;
        return (
            JSON.parse(
                getGlobalStorage('localStorage', 'ColumnConfigWidth') || '{}',
            )[configKey] || {}
        );
    };

    // 将props转化为state
    propsToState = props => {
        if (props.isDefaultCheckDisableData !== this.props.isDefaultCheckDisableData) {
            if (props.isDefaultCheckDisableData !== this.state.isShowDisabledData) {
                this.setState({ isShowDisabledData: props.isDefaultCheckDisableData });
            }
        }
        let { disabled } = props,
            value = this.getTrueValue(props);

        if (disabled) {
            this.setState({ dropDownShow: false });
        }

        // 同步props.value到state.selectedValues，保证外部输入的value和内部统一
        // 同步referVal
        // props.value 外部传进来的值
        // this._value 实际选中的值（上次选中的值）
        // state.selectedValue 当前选中的值（还没点确定）
        let { selectedValues } = this.state;
        let innerValue, outerValue;

        if (props.isMultiSelectedEnabled) {
            // 多选
            let o = new Map();
            Array.isArray(value) || (value = []);
            innerValue = [...(this._value || new Map()).keys()];
            outerValue = value.map(e => e.refpk);
            if (!compareArr(innerValue, outerValue)) {
                value.forEach(e => {
                    e.refpk && o.set(e.refpk, e);
                });
                selectedValues = o;
                this._value = new Map(
                    JSON.parse(JSON.stringify(selectedValues)),
                );
                // !isEdit && !isShowStatus &&
                // let dropDownShow = this.state.dropDownShow;
                // let isSelectedShow = dropDownShow? true : this.state.isSelectedShow;
                this.setState({
                    selectedValues,
                    dropDownShow: false,
                    referVal: this.getDisplayOrValue(value, 'display', props),
                });
            }
        } else {
            innerValue = [...(this._value || new Map()).keys()][0] || '';
            outerValue = value?.refpk ?? '';
            // 单选
            if (innerValue !== outerValue) {
                // 新旧值不等
                if (value?.refpk) {
                    selectedValues = new Map(
                        Object.entries({ [value.refpk]: value }),
                    );
                    this._value = new Map(
                        JSON.parse(JSON.stringify(selectedValues)),
                    );
                    // !isEdit && !isShowStatus &&
                    // let dropDownShow = this.state.dropDownShow;
                    // let isSelectedShow = dropDownShow? true : this.state.isSelectedShow;
                    this.setState({
                        selectedValues,
                        dropDownShow: false,
                        referVal: this.getDisplayOrValue(
                            value,
                            'display',
                            props,
                        ),
                    });
                } else {
                    // !isEdit && !isShowStatus &&
                    selectedValues = new Map();
                    this._value = new Map(
                        JSON.parse(JSON.stringify(selectedValues)),
                    );
                    this.setState({ selectedValues, referVal: '' });
                }
            }
        }
        this.setState({
            // selectedValues,
            // selectedKeys: this.state.selectedKeys,
            columnConfig:
                typeof this.getColumnConfig === 'function' &&
                this.getColumnConfig(props),
        });
    };

    refreshTip = () => {
        if (this.refreshFlag) {
            this.referTable &&
                (this.referTable.querySelector(
                    `.refer-base-table-scroll-body`,
                ).scrollTop = 0);
            toast({
                color: 'success',
                content: this.state.jsonInsideRefer['containers-refer-0048'],
            });
            this.refreshFlag = false;
        }
    };

    // 刷新
    refresh = (clearCache = true) => {
        this.refreshFlag = true;
        let { pageSize, rootNode, refType, idKey } = this.props,
            { selectedKeys, paginationRefreshKey, tableData, selectedValues } =
                this.state;

        //直接删除树数据，点击刷新，已选数据未更新
        // let newTableData = [];
        // let selectedAllKeys = selectedValues.keys();
        // if (
        //     refType === 'tree' &&
        //     selectedAllKeys.length !== tableData[0].rows.length &&
        //     tableData[0].rows.length > 0
        // ) {
        //     tableData[0].rows.forEach((e) => {
        //         if (selectedAllKeys.includes(e.refpk)) {
        //             newTableData.push(e);
        //         }
        //     });
        //     tableData[0].rows = cloneDeep(newTableData);
        //     this._value.forEach((e) => {
        //         if (!selectedAllKeys.includes(e.refpk)) {
        //             this._value.delete(e.refpk);
        //         }
        //     });
        // }

        // state数据清空
        let defaultState = {
            tableData: [
                {
                    rows: tableData[0].rows,
                    page: tableData[0].page ? {
                        pageIndex: 0,
                        pageSize,
                        totalPage: 1,
                        total: tableData[0].rows?.length,
                    } : tableData[0].page,
                },
            ], // 参照的数据
            treeData: [rootNode], // 左树的值
        };
        // 缓存数据清空
        this.clearCache();
        // 树表时清除左树选中
        if (refType === 'gridTree') {
            selectedKeys = [];
        }
        // 清空搜索框
        let newState = {
            ...defaultState,
            selectedKeys,
            searchVal: '',
            treeSearchVal: '',
            isTreeSearch: false,
            isSearch: false,
            expandedKeys: [rootNode[idKey]],
            paginationRefreshKey: ++paginationRefreshKey,
            usePagaPageInfo:false,
        };
        clearCache &&
            (newState.selectedValues = new Map(
                JSON.parse(JSON.stringify(this._value)),
            )); // 已选恢复到点开时
        this.setState(newState, () => {
            // 查全部数据
            this.show(true, clearCache);
        });
    };

    // 刷新
    refreshTree = (clearCache = true) => {
        this.refreshFlag = false;
        let { pageSize, rootNode, refType, idKey } = this.props,
            { selectedKeys, paginationRefreshKey, tableData } = this.state;
        // state数据清空
        let defaultState = {
            tableData: [
                {
                    rows: tableData[0].rows,
                    page: {
                        pageIndex: 0,
                        pageSize,
                        totalPage: 1,
                    },
                },
            ], // 参照的数据
            treeData: [rootNode], // 左树的值
        };
        // 缓存数据清空
        this.clearCache();
        // 树表时清除左树选中
        if (refType === 'gridTree') {
            selectedKeys = [];
        }
        // 清空搜索框
        let newState = {
            ...defaultState,
            selectedKeys,
            searchVal: '',
            treeSearchVal: '',
            isTreeSearch: false,
            isSearch: false,
            expandedKeys: [rootNode[idKey]],
            paginationRefreshKey: ++paginationRefreshKey,
        };
        clearCache &&
            (newState.selectedValues = new Map(
                JSON.parse(JSON.stringify(this._value)),
            )); // 已选恢复到点开时
        this.setState(newState);
    };

    // 格式转化（单选 or 多选）：{ display, value } => {refname, refpk}
    foolValueToValue = (fool, props) => {
        const { isMultiSelectedEnabled } = props;
        let finalVal;
        fool.display = fool.display || '';
        fool.value = fool.value || '';
        if (isMultiSelectedEnabled) {
            let { display, value, refpk, ...arr } = fool;
            // 多选 { display: '1,3', value: '2,4' } => [{refname: '1', refpk: '2'}, {refname: '3', refpk: '4'}]
            let foolDisplays = fool.display.split(','),
                foolValues = fool.value.split(','),
                foolRefpk = [];
            if (refpk && typeof refpk === 'string') {
                foolRefpk = refpk.split(',');
            }
            finalVal = [];
            !foolDisplays[0] && (foolDisplays = []);
            !foolValues[0] && (foolValues = []);
            !foolRefpk[0] && (foolRefpk = []);
            foolValues
                .filter(e => e)
                .forEach((e, i) => {
                    finalVal.push(
                        this.foolToSmart(
                            {
                                refpk: foolRefpk[i],
                                ...(arr[i] || {}),
                                display: foolDisplays[i],
                                value: e,
                            },
                            props,
                        ),
                    );
                });
            // finalVal = arr;
        } else {
            finalVal = this.foolToSmart(fool, props);
        }

        return finalVal;
    };

    // 格式转化（单选）：{ display, value } => {refname, refpk}
    foolToSmart = (fool, props) => {
        let { selectedValues } = this.state;
        let { fieldDisplayed, fieldValued, fieldSplitSep } = props;
        fool.display = fool.display || '';
        fool.value = fool.value || '';
        fool.refpk = fool.refpk || '';
        if (/^#.*#$/.test(fool.refpk)) {
            // 如果refpk是函数,不使用,走正常流程
            delete fool.refpk;
        }

        if (selectedValues.has(fool.value)) {
            return selectedValues.get(fool.value);
        }

        let foolDisplay = fool.display,
            foolValue = fool.value,
            foolRefpk = fool.refpk,
            smart = { ...fool };
        if (fieldDisplayed.includes(fieldSplitSep)) {
            // fieldDisplayed包含指定分隔符时，表示是多字段展示。
            fieldDisplayed = fieldDisplayed.split(fieldSplitSep);
            foolDisplay = fool.display.split('/');
        }

        if (foolValue) {
            Array.isArray(fieldDisplayed)
                ? fieldDisplayed.forEach((e, i) => {
                    smart[e] = foolDisplay[i];
                })
                : (smart[fieldDisplayed] = foolDisplay);
            // smart[fieldValued] = foolValue;
            smart[fieldValued] = smart[fieldValued] || foolValue;
            smart.refpk = smart.refpk || foolRefpk || foolValue;
            // typeof fieldDisplayed === 'string' && (smart[fieldDisplayed] = smart[fieldDisplayed] || smart[fieldValued]);
            return smart;
        } else {
            return {};
        }
    };

    // 是否命中缓存
    hasCache = (url, param) => {
        let cacheData = ViewModel.getData('referCache') || [],
            cache = cacheData.find(e => {
                return e.url === url && compare(param, e.param);
            });
        if (cache) {
            this.setCacheData(url, param, cache.data);
            return cache.data;
        } else {
            return null;
        }
    };

    // 将数据存入缓存--命中缓存仍存数据的原因是缓存数据的顺序
    setCacheData = (url, param, data) => {
        param = JSON.parse(JSON.stringify(param));
        data = JSON.parse(JSON.stringify(data));
        let { maxCacheNum } = this.props,
            cacheData = ViewModel.getData('referCache') || [];
        let i = cacheData.findIndex(e => {
            return e.url === url && compare(param, e.param);
        });
        if (i > -1) {
            cacheData.splice(i, 1);
        }

        cacheData.push({
            url,
            param,
            data,
        });
        while (cacheData.length > maxCacheNum) {
            cacheData.shift();
        }
        ViewModel.setData('referCache', cacheData);
    };

    // 清空缓存
    clearCache = () => {
        ViewModel.setData('referCache', []);
    };

    // 根据pk顺序排序
    sortRowsByPk = (rows, pks, checkStrictly) => {
        let rowMap = {},
            { fieldDisplayed, fieldValued } = this.props,
            res = [];

        (rows || []).forEach(row => {
            rowMap[row.refpk] = row;
        });

        pks.map(pk => {
            if (rowMap[pk]) {
                res.push(rowMap[pk]);
            } else if (!checkStrictly) {
                res.push({
                    refname: pk,
                    refcode: pk,
                    refpk: pk,
                    [fieldDisplayed]: pk,
                    [fieldValued]: pk,
                });
            }
        });

        return res;
    };

    // 业务组复写：获取请求参数
    getParam = () => {
        return {};
    };

    // 获取请求参数
    __getParam = (param = {}) => {
        let {
                queryCondition,
                refType,
                isShowUnit,
                isShowDisabledData,
                isHasDisabledData,
                pk_defdoclist,
                dataPowerOperationCode,
                isDataPowerEnable,
                unitProps,
                extraParam,
                refRelyCondition,
                referCondition = {},
                isgrouppower,
                refcode,
                rootNode,
                idKey,
                isTreelazyLoad,
                pageSize,
            } = this.props,
            { isShow, tableData } = this.state,
            {
                keyword = '',
                pid = '',
                pageInfo = {},
                searchPks,
                filterPks,
                loadSelectedData = false,
                multiPid = {},
            } = param;
        pageInfo = {
            // pageSize: pageInfo.pageSize || tableData[0].page.pageSize,//和表格数据同步的话，下拉表格与弹窗共用一个tableData,下拉表格中历史记录数据可能更少
            pageSize: pageInfo.pageSize || pageSize,

            pageIndex: pageInfo.pageIndex || (refType === 'tree' ? -1 : 0),
        };
        if (pageInfo.pageSize == -1) {
            pageInfo.pageIndex = -1;
        }

        let extraCondition = {};
        !loadSelectedData &&
            unitProps &&
            isShowUnit &&
            (extraCondition[unitProps.key || 'unitPks'] =
                Array.isArray(this.state.unit) && this.state.unit.length
                    ? this.state.unit.map(e => e.refpk).join(',')
                    : (this.state.unit || {}).refpk);
        isHasDisabledData &&
            isShowDisabledData &&
            (extraCondition.isShowDisabledData = this.state.isShowDisabledData);
        !isShow && keyword && (extraCondition.searchFlag = true);
        extraCondition.isShowUnit = !!isShowUnit;
        // 模板上会返回下面几个属性
        pk_defdoclist !== undefined &&
            (extraCondition.pk_defdoclist = pk_defdoclist);
        dataPowerOperationCode !== undefined &&
            (extraCondition.DataPowerOperationCode = dataPowerOperationCode);
        isDataPowerEnable !== undefined &&
            (extraCondition.isDataPowerEnable = isDataPowerEnable);
        isgrouppower !== undefined &&
            (extraCondition.isgrouppower = isgrouppower);
        loadSelectedData && (extraCondition.loadSelectedData = true);
        refcode && (extraCondition.refpath = refcode);

        let finalExtraParam = {};
        if (typeof extraParam === 'object') {
            finalExtraParam = extraParam || {};
        } else if (typeof extraParam === 'function') {
            finalExtraParam = extraParam();
        }

        let final = {
            ...param,
            pid:
                pid === (rootNode.refpk || rootNode[idKey]) && !isTreelazyLoad
                    ? ''
                    : pid, // 对应的树节点
            keyword,
            // defineItems: this.getSearchConfigCodes(), // 搜索设置字段
            queryCondition: {
                // 业务的过滤条件
                ...(typeof queryCondition === 'function'
                    ? queryCondition(this.props)
                    : typeof queryCondition === 'object'
                        ? queryCondition
                        : {}),
                ...(typeof referCondition === 'function'
                    ? referCondition(this.props)
                    : typeof referCondition === 'object'
                        ? referCondition
                        : {}),
                ...multiPid,
            },
            pageInfo,
            ...this.getParam(param || {}),
            ...finalExtraParam,
        };

        if (keyword && Array.isArray(filterPks) && filterPks.length) {
            final.filterPks = filterPks;
        } else {
            delete final.filterPks;
        }

        final.queryCondition = { ...extraCondition, ...final.queryCondition };

        let refRelyConditionArray = refRelyCondition?.() ?? [];

        let refRelyConditionObject = refRelyConditionArray.reduce(
            (refRelyConditionObject, condition) => {
                let { key, value, nofilter } = condition;
                final.queryCondition[key] = value;
                if (!nofilter) {
                    refRelyConditionObject[key] = value;
                }
                return refRelyConditionObject;
            },
            {},
        );

        final.refRelyCondition = refRelyConditionObject;

        if (Array.isArray(searchPks) && searchPks.length) {
            final.searchPks = searchPks;
            final.pageInfo.pageSize = searchPks.length;
        }

        return final;
    };

    // 请求列表数据
    loadTableData = async (param, useCache = true, loading = true) => {
        const { queryGridUrl, refType, pageSize, pageid, ts } = this.props;
        if (!queryGridUrl) {
            return {
                rows: [],
                page: {
                    pageIndex: 0,
                    pageSize: pageSize,
                    totalPage: 1,
                },
            };
        }
        let { isUsualStatus } = this.getStatus();
        if (refType === 'gridTree' && !param.pid) {
            param.filterPids = await this.loadTreeData(
                this.__getParam({ pageInfo: { pageIndex: -1 } }),
                true,
                false,
            ).then(data => {
                return data.rows.map(e => e.refpk);
            });
        }
        if (isUsualStatus) {
            param.queryCondition.isShowUsual = true;
            param.queryCondition.UsualActionURL = queryGridUrl;
        }
        // param.defineItems = this.getSearchConfigCodes();
        param['defineItems'] =
            this.getSearchConfigCodes().filter(e => {
                return e !== 'refcode' && e !== 'refname';
            }) || [];
        param.pageid = pageid;
        param.ts = ts;
        return this.sendAjax(queryGridUrl, param, useCache, loading).then(
            data => {
                return data;
            },
        );
    };

    // 请求树数据
    loadTreeData = async (
        param,
        useCache = true,
        loading = true,
        hasExtraTreeData,
    ) => {
        const {
            queryTreeUrl,
            refType,
            useExtraTreeData,
            extraTreeData,
            extraFilterTreeData,
        } = this.props;
        if (refType === 'gridTree') {
            delete param.refRelyCondition;
        }
        if (
            typeof extraFilterTreeData === 'function' &&
            refType === 'tree' &&
            useExtraTreeData &&
            !hasExtraTreeData
        ) {
            return extraFilterTreeData(param);
        }
        if (refType === 'tree' && useExtraTreeData) {
            return extraTreeData;
        }
        return this.sendAjax(queryTreeUrl, param, useCache, loading);
    };

    // 发送ajax请求
    sendAjax = (url, param, useCache, loading) => {
        let {
                isCacheable,
                unitProps,
                isShowUnit,
                unitValueIsNeeded,
                async,
                ajaxParam = {},
            } = this.props,
            { unit } = this.state;

        if (unitProps && isShowUnit && unitValueIsNeeded) {
            let unitVal =
                Array.isArray(unit) && unit.length
                    ? unit.map(e => e.refpk).join(',')
                    : (unit || {}).refpk;
            if (!unitVal) {
                // 有业务单元，但是没有选值时，不发请求，清空数据
                return Promise.resolve({
                    page: {
                        pageSize: 50,
                        pageIndex: 0,
                    },
                    rows: [],
                });
            }
        }
        if (param?.pageInfo?.pageSize) {
            param.pageInfo.pageSize = Number(param.pageInfo.pageSize);
        }
        if (param?.pageInfo?.pageIndex) {
            param.pageInfo.pageIndex = Number(param.pageInfo.pageIndex);
        }
        let cacheData = this.hasCache(url, param);
        if (useCache && isCacheable && cacheData) {
            this.enterKeybord = true;
            return Promise.resolve(cacheData);
        } else {
            return new Promise(resolve => {
                this.setState({ loading: loading && true }, () => {
                    this.isFetching = true;
                    ajax({
                        async,
                        url,
                        data: param,
                        loading: false,
                        // sysAppcode: microAppUtil.getInsideAppCode(),
                        ...ajaxParam,
                        success: res => {
                            this.isFetching = false;
                            this.enterKeybord = true;
                            if (!res.success) {
                                throw new Error(res.error.message);
                            }
                            if (res.data && res.data.message) {
                                this.refreshFlag = false;
                                toast({
                                    color: 'warning',
                                    content: res.data.message,
                                });
                            }
                            isCacheable &&
                                this.setCacheData(url, param, res.data);
                            resolve(res.data);
                        },
                        error: e => {
                            this.isFetching = false;
                            toast({
                                color: e.type || 'danger',
                                content: e.message,
                            });
                            this.setState({ loading: false });
                            // throw new Error(e);
                        },
                    });
                });
            });
        }
    };

    // 请求列表数据
    loadTableDataSync = (param, useCache = true, loading = true, useUsual) => {
        const { queryGridUrl, refType, pageSize, pageid, ts } = this.props;
        if (!queryGridUrl) {
            return {
                rows: [],
                page: {
                    pageIndex: 0,
                    pageSize: pageSize,
                    totalPage: 1,
                },
            };
        }
        let { activeKey } = this.state;
        if (refType === 'gridTree' && !param.pid) {
            param.filterPids = this.loadTreeDataSync(
                this.__getParam({
                    pageInfo: {
                        pageIndex: -1,
                        pageSize: this.state.tableData[0].page.pageSize,
                    },
                }),
                useCache,
                loading,
            ).rows.map(e => e.refpk);
        }
        if (refType === 'gridTree' && activeKey === '2' && !useUsual) {
            param.queryCondition.isShowUsual = true;
            param.queryCondition.UsualActionURL = queryGridUrl;
        }
        // param.defineItems = this.getSearchConfigCodes();

        param['defineItems'] =
            this.getSearchConfigCodes().filter(e => {
                return e !== 'refcode' && e !== 'refname';
            }) || [];

        param.pageid = pageid;
        param.ts = ts;
        let data = this.sendAjaxSync(queryGridUrl, param, useCache, loading);
        return data;
    };

    // 请求树数据
    loadTreeDataSync = (param, useCache = true, loading = true) => {
        // const { queryTreeUrl } = this.props;
        // return this.sendAjaxSync(queryTreeUrl, param, useCache, loading);

        const {
            queryTreeUrl,
            refType,
            useExtraTreeData,
            extraTreeData,
            extraFilterTreeData,
        } = this.props;
        if (refType === 'gridTree') {
            delete param.refRelyCondition;
        }

        if (
            typeof extraFilterTreeData === 'function' &&
            refType === 'tree' &&
            useExtraTreeData
        ) {
            return extraFilterTreeData(param);
        }
        if (refType === 'tree' && useExtraTreeData) {
            return extraTreeData;
        }
        return this.sendAjaxSync(queryTreeUrl, param, useCache, loading);
    };

    sendAjaxSync = (url, param, useCache) => {
        let {
                isCacheable,
                unitProps,
                isShowUnit,
                unitValueIsNeeded,
                ajaxParam = {},
            } = this.props,
            { unit } = this.state;

        if (unitProps && isShowUnit && unitValueIsNeeded) {
            let unitVal =
                Array.isArray(unit) && unit.length
                    ? unit.map(e => e.refpk).join(',')
                    : (unit || {}).refpk;
            if (!unitVal) {
                // 有业务单元，但是没有选值时，不发请求，清空数据
                return {
                    page: {
                        pageSize: 50,
                        pageIndex: 0,
                    },
                    rows: [],
                };
            }
        }
        if (param?.pageInfo?.pageSize) {
            param.pageInfo.pageSize = Number(param.pageInfo.pageSize);
        }
        if (param?.pageInfo?.pageIndex) {
            param.pageInfo.pageIndex = Number(param.pageInfo.pageIndex);
        }
        let cacheData = this.hasCache(url, param);
        if (useCache && isCacheable && cacheData) {
            return cacheData;
        } else {
            this.isFetching = true;
            let data;
            ajax({
                async: false,
                url,
                data: param,
                loading: false,
                // sysAppcode: microAppUtil.getInsideAppCode(),
                ...ajaxParam,
                success: res => {
                    this.isFetching = false;
                    this.setState({ loading: false });
                    if (!res.success) {
                        throw new Error(res.error.message);
                    }
                    isCacheable && this.setCacheData(url, param, res.data);
                    data = res.data;
                },
                error: e => {
                    this.isFetching = false;
                    toast({
                        color: e.type || 'danger',
                        content: e.message,
                    });
                    this.setState({ loading: false });
                    // throw new Error(e);
                },
            });
            return data;
        }
    };

    //获取数据values里面的属性值
    getRowValuesBykey = (rowData, key) => {
        return rowData?.[key] || rowData?.values?.[key]?.value;
    };
    // 设置表格数据
    setTableData = (target, level, data) => {
        let targetData = this.state[target];
        targetData[level] = {
            page: data.page,
            rows: (targetData[level].rows || []).concat(data.rows),
        };
        if (data.page && data.page.pageIndex == 0) {
            this.allpks = data.page.allpks || [];
            this.totalPage = data.page.totalPage;
        }
        targetData[level].page &&
            (targetData[level].page.totalPage = this.totalPage || 0);
        this.setState({ [target]: targetData }, () => {
            this.refreshTip();
        });
    };

    // 设置树数据
    setTreeData = (target, parentNode, data, cb) => {
        let { idKey, pidKey, rootNode, refType } = this.props,
            {
                expandedKeys,
                group,
                treeDataWithChildren,
                keyMap,
                isTreeSearch,
            } = this.state;

        if (refType === 'tree') {
            this.setState({ loading: false });
        }

        if (rootNode.refname === '根节点') {
            rootNode.refname =
                this.state.jsonInsideRefer['containers-refer-0040'] || '根节点';
        }

        // 把父节点下的节点清空
        if (parentNode[idKey]) {
            // 防止修改originGroup的引用
            group = { ...group };
            (function test(pid) {
                if (group[pid]) {
                    group[pid].map(node => {
                        test(node[idKey]);
                    });
                    group[pid] = [];
                }
            })(parentNode[idKey]);
        }
        rootNode['refpk'] = rootNode['refpk'] || rootNode[idKey];
        // 重置根节点
        group['undefined'] = rootNode;
        let treeData = this.groupToArray(group),
            dataMap = {};
        if (isArray(data.rows)) {
            treeData = treeData.concat(data.rows);
        }

        // treeData = treeData.concat(data.rows);

        let virtualNodeSet = new Set();
        if (isArray(data.rows)) {
            data.rows.forEach(e => {
                // if(e.refcode==='AIM') e.disabled = true;
                // if(e.refcode==='AIM') e.values.virtualRootNote = { value: true };
                // 每一个节点存有一个key属性，用来表示该节点的全路径;pKey表示父节点的全路径
                e._display = this.props.treeConfig.code
                    .map(field => this.getDisplayOrValue(e, field))
                    .join(' ');
                e[pidKey] = e[pidKey] || parentNode[idKey];
                e['refpk'] = e['refpk'] || e[idKey];
                dataMap[e[idKey]] = e;
                if (this.getRowValuesBykey(e, 'virtualRootNote')) {
                    virtualNodeSet.add(e[idKey]);
                }
            });
        }

        // 处理expandedKeys
        if (this._expandedKeys && !isTreeSearch) {
            // 恢复到搜索之前的状态
            expandedKeys = this._expandedKeys;
            delete this._expandedKeys;
        } else if (isTreeSearch) {
            // 搜索时展开全部
            expandedKeys = treeData.map(e => e[idKey]);
        } else {
            // 新加进来的节点，展开都设为false
            // fix: 再打开时保留上次的展开状态，所以注释到下面那行
            // expandedKeys = expandedKeys.filter(e => !dataMap[e]).concat([parentNode[idKey]]);
        }

        // 处理数据格式
        ({ group, treeDataWithChildren, treeData, keyMap } =
            this.arrayToGroup(treeData));
        const stateData = {
            [target]: treeData,
            expandedKeys,
            group,
            treeDataWithChildren,
            virtualNodeSet,
        };
        if (!isTreeSearch) {
            this.originGroup = group;
            this.originKeyMap = keyMap;
            stateData.keyMap = keyMap;
        }
        this.setState(
            stateData,
            () => {
                this.run(cb, data);
                refType === 'tree' && this.refreshTip();
            },
        );
    };

    // 分组数据 => 树数组数据
    groupToArray = group => {
        let arr = [];
        Object.keys(group).forEach(key => {
            arr = arr.concat(group[key]);
        });
        return arr;
    };

    // 树数组数据 => 分组数据
    arrayToGroup = treeData => {
        const { idKey, pidKey, rootNode } = this.props;
        let group = {},
            keyMap = {},
            rootNodePk = rootNode[idKey];
        treeData.forEach(e => {
            let { children, ...others } = e;
            keyMap[e[idKey]] = e;

            group[e[pidKey]]
                ? group[e[pidKey]].push(others)
                : (group[e[pidKey]] = [others]);
        });
        //先把state中的keyMap改了 xiqq
        // this.state.keyMap = keyMap;
        // this.setState({ keyMap });
        // 如果没有可以挂载的节点，就挂到根节点上
        Object.keys(group).forEach(pid => {
            if (pid !== 'undefined' && pid !== rootNodePk && !keyMap[pid]) {
                group[rootNodePk]
                    ? group[rootNodePk].push(...group[pid])
                    : (group[rootNodePk] = [...group[pid]]);
                delete group[pid];
            }
        });

        // 构造树结构
        let treeDataWithChildren = this.groupToTree(group, group['undefined']);
        // 转回数组结构，其中包含了disabled属性和level属性
        treeData = this.treeToArray(treeDataWithChildren);
        return {
            group,
            treeDataWithChildren,
            treeData,
            keyMap,
        };
    };

    // 分组数据 => 树数组数据--构造树结构,把数据转换成树形式，即每一个节点包含children（这个数据方便看）
    groupToTree = (group, data, level = 0, index = { value: 0 }) => {
        let { idKey, rootNode } = this.props;
        let { isTreeSearch } = this.state;
        if (!data) {
            return null;
        }
        return data.map(e => {
            let disabled = rootNode[idKey] !== e[idKey] && this.isDisabled(e);
            e.disabled = disabled;
            e.index = ++index.value;
            e.level = level;
            e.key = e[idKey];
            //某树节点的refpk若为undefined，可能会导致递归死循环，导致爆栈，这里是否加个提示
            let children = this.groupToTree(
                group,
                group[e[idKey]],
                level + 1,
                index,
            );

            if (Array.isArray(children)) {
                e.children = children;
            }
            if (!e.hasOwnProperty('isleaf')) {
                e.isleaf = !(Array.isArray(children) && children.length);
            }
            return e;
        });
    };

    // 树形数据 => 树数组数据,树形数据拍平
    treeToArray = (tree, arr = []) => {
        if (Array.isArray(tree)) {
            tree.forEach(e => {
                let { children, ...others } = e;
                arr.push({ ...others });
                if (Array.isArray(e.children)) {
                    this.treeToArray(e.children, arr);
                }
            });
        }

        return arr;
    };

    // 获取一个值的某个（些）field值---返回'refname/refcode'或refpk
    getOneDisplayOrValue = (item, field, sep) => {
        return Array.isArray(field)
            ? field
                .map(
                    e =>
                        item[e] ||
                          (item.values &&
                              item.values[e] &&
                              (item.values[e].display ||
                                  item.values[e].value)) ||
                          '',
                )
                .join(sep)
            : item[field] ||
                  (item.values &&
                      item.values[field] &&
                      (item.values[field].display ||
                          item.values[field].value)) ||
                  '';
    };

    // 获取多个值的某个field值---返回'refname/refcode'，若有多个值中间用','分隔开,field控制返回的值
    getDisplayOrValue = (items, field, props) => {
        let { fieldDisplayed, fieldValued, fieldSplitSep, fieldJoinSep } =
            props || this.props;
        if (field === 'display') {
            if (fieldDisplayed.includes(fieldSplitSep)) {
                field = fieldDisplayed.split(fieldSplitSep);
            } else {
                field = fieldDisplayed;
            }
        } else if (field === 'value') {
            field = fieldValued;
        }
        return items
            ? Array.isArray(items)
                ? items
                    .map(e =>
                        this.getOneDisplayOrValue(e, field, fieldJoinSep),
                    )
                    .join(',')
                : this.getOneDisplayOrValue(items, field, fieldJoinSep)
            : '';
    };

    // 获取参照的实际值
    getTrueValue = props => {
        let { foolValue, value } = props || this.props;
        return foolValue
            ? this.foolValueToValue(foolValue, props || this.props)
            : value;
    };

    // 判断前后两次选中的值是否一样
    isEqual = (newValue, oldValue) => {
        let {
                isMultiSelectedEnabled,
                refType,
                onlyLeafCanSelect,
                isRunWithChildren,
                isAlwaysEmitOnChange,
            } = this.props,
            isEqual;

        if (isMultiSelectedEnabled) {
            isEqual = compareArr(newValue, oldValue);
        } else {
            isEqual = (newValue || {}).refpk === (oldValue || {}).refpk;
        }

        if (
            isMultiSelectedEnabled &&
            refType === 'tree' &&
            !onlyLeafCanSelect &&
            isRunWithChildren &&
            this.runWithChildren !== !!this.state.runWithChildren
        ) {
            // 当有【执行时包含下级】且两次勾选情况不一样时，触发编辑后
            isEqual = false;
        }

        if (isAlwaysEmitOnChange) {
            isEqual = false;
        }

        return isEqual;
    };

    // 单选的方法
    singleSelect = async (item, del, clear) => {
        // 添加clear 參數 用於控制 清空时展开历史记录 by bbqin
        // 单选
        let {
                onChange,
                extraOnChange,
                isMultiSelectedEnabled,
                type,
                needQuerySelectedDataBeforeOnChange,
            } = this.props,
            value = this.getTrueValue(),
            { selectedValues, referVal, isShow } = this.state,
            { isSearchStatus, isSelectedStatus } = this.getStatus();
        item = item || [...selectedValues.values()][0];

        if (!isMultiSelectedEnabled && del === true) {
            item = {};
        }

        //如果是下拉并且已经弹出了，让它收起
        if (type === 'dropDown' && isShow) {
            this.focusFlag = false;
            this.referInput && this.referInput.blur(); //这个输入框失焦要不加个延时，放到最后执行
            this.setState({ isShow: false });
        }

        // 多选时的【搜索】和【已选】不失焦不收起，其余都失焦且收起
        // 搜索下拉的所有项被选中时，收起
        // todo:添加判断条件，下拉的所有项双击时收起
        // if (!(isMultiSelectedEnabled && (isSearchStatus || isSelectedStatus))) {
        //     this.setState(
        //         {
        //             // dropDownShow: false, // 搜索和历史记录下拉是否显示
        //             // isSelectedShow: false, //是否显示已选择

        //             dropDownShow: true, // 搜索和历史记录下拉是否显示
        //             isSelectedShow: true, //是否显示已选择
        //         },
        //         () => {
        //             //  // UE说选中下拉之后要聚焦  by bbqin
        //             //  if (this.hotKeyClose || this.clearFlag || this.focusFlag) {
        //             // 	 this.referInput && this.referInput.focus();
        //             // 	 this.focusFlag = true;
        //             //  } else {
        //             // 	 this.focusFlag = false;
        //             // 	 this.referInput && this.referInput.blur();
        //             //  }
        //         }
        //     );
        // }

        if (!isMultiSelectedEnabled) {
            this.setState(
                {
                    dropDownShow: false, // 搜索和历史记录下拉是否显示
                    isSelectedShow: false, //是否显示已选择
                    showHistoryFlag: false,

                    // dropDownShow: true, // 搜索和历史记录下拉是否显示
                    // isSelectedShow: true, //是否显示已选择
                },
                () => {
                    //  // UE说选中下拉之后要聚焦  by bbqin
                    //  if (this.hotKeyClose || this.clearFlag || this.focusFlag) {
                    // 	 this.referInput && this.referInput.focus();
                    // 	 this.focusFlag = true;
                    //  } else {
                    // 	 this.focusFlag = false;
                    // 	 this.referInput && this.referInput.blur();
                    //  }
                },
            );
        }

        // 判断前后两次选中的值是否一样，一样的话则不做任何处理
        let isEqual = this.isEqual(
            isMultiSelectedEnabled ? [item] : item,
            value,
        );

        // 如果选中的是fx函数
        if (item && /^#.*#$/.test(item.refpk)) {
            selectedValues = new Map();
        }

        if (item && item.refpk) {
            if (isMultiSelectedEnabled) {
                // 存入已选择--下面这个方法相当于往selectedValues中存值，若selectedValues中存在该值，则删除之
                this.toggleValueForMapOrObject(
                    selectedValues,
                    item.refpk,
                    item,
                );
                referVal = this.getDisplayOrValue(
                    [...selectedValues.values()],
                    'display',
                );

                // 保证onChange的执行顺序
                this.state.referVal = referVal;
                this.state.selectedValues = selectedValues;

                let selections = this.getSelections();
                //是否有外部传进来的SelectedData并被使用
                if (needQuerySelectedDataBeforeOnChange) {
                    selections = await this.loadSelectedData(selections);
                }
                let foolDisplay = this.getDisplayOrValue(selections, 'display'),
                    foolValue = this.getDisplayOrValue(selections, 'value');

                let emitOnChange =
                    !isEqual &&
                    !(
                        (isSearchStatus || isSelectedStatus) &&
                        isMultiSelectedEnabled
                    );
                emitOnChange &&
                    (this._value = new Map(
                        JSON.parse(JSON.stringify(selectedValues)),
                    ));

                this.run(
                    [emitOnChange && onChange, emitOnChange && extraOnChange],
                    selections,
                    {
                        display: foolDisplay,
                        value: foolValue,
                    },
                );
                if (del === true && !selections.length) {
                    this.focusFlag = false;
                    this.referInput && this.referInput.blur();
                    this.setState({
                        isSelectedShow: clear === true,
                        dropDownShow: false,
                    });
                }

                // fix bug: 选历史记录触发onChange，onChange里清空值，再失去焦点，会触发两次onChange
                // onItemClick是异步执行，导致setState强转为同步，所以这里取state里的最新值
                this.setState({
                    selectedValues: this.state.selectedValues,
                    referVal,
                });
            } else {
                // 存入已选择
                selectedValues = new Map(
                    Object.entries({ [item.refpk]: item }),
                );

                let foolDisplay = this.getDisplayOrValue(item, 'display'),
                    foolValue = this.getDisplayOrValue(item, 'value');
                referVal = foolDisplay;

                this.state.selectedValues = selectedValues;
                this.state.referVal = referVal;

                !isEqual &&
                    (this._value = new Map(
                        JSON.parse(JSON.stringify(selectedValues)),
                    ));

                this.run(
                    [!isEqual && onChange, !isEqual && extraOnChange],
                    item,
                    {
                        display: foolDisplay,
                        value: foolValue,
                    },
                    { isDefaultCheckDisableData: this.state.isShowDisabledData },
                );

                // fix bug: 选历史记录触发onChange，onChange里清空值，再失去焦点，会触发两次onChange
                // onItemClick是异步执行，导致setState强转为同步，所以这里取state里的最新值
                this.setState({
                    selectedValues: this.state.selectedValues,
                    referVal: this.state.referVal,
                });
            }
            // 存入历史记录localStorage
            this.pushToLocal(item);
        } else {
            selectedValues = new Map();

            this.state.selectedValues = selectedValues;

            !isEqual &&
                (this._value = new Map(
                    JSON.parse(JSON.stringify(selectedValues)),
                ));
            this.run(
                [!isEqual && onChange, !isEqual && extraOnChange],
                {},
                { display: '', value: '' },
            );

            // fix bug: 选历史记录触发onChange，onChange里清空值，再失去焦点，会触发两次onChange
            // onItemClick是异步执行，导致setState强转为同步，所以这里取state里的最新值
            this.setState({
                selectedValues: this.state.selectedValues,
                referVal: '',
            });
        }

        this.setState({ isMoreButtonShow: false }, () => {
            if (this.clearFlag) {
                this.clearFlag = false;
            }
        });
    };

    // 多选的方法
    multiSelect = async () => {
        let selections = this.getSelections(),
            {
                onChange,
                extraOnChange,
                maxChoice,
                needQuerySelectedDataBeforeOnChange,
            } = this.props;

        if (selections.length > maxChoice) {
            // 最多选择***条数据
            toast({
                color: 'warning',
                // eslint-disable-next-line no-template-curly-in-string
                content: `${(
                    this.state.jsonInsideRefer['containers-refer-0000'] || ''
                )
                    // eslint-disable-next-line no-template-curly-in-string
                    .replace('${0000}', maxChoice)}`,
            });
            return false;
        }

        let isEqual = this.isEqual(
            selections.map(e => e.refpk),
            [...this._value.keys()],
        );

        isEqual || this.pushToLocal([...selections]); // 存入历史记录localStorage

        let index =
            selections.length > 1
                ? selections.findIndex(e => /^#.*#$/.test(e.refpk))
                : -1;

        if (index !== -1) {
            selections.splice(index, 1);
        }

        if (needQuerySelectedDataBeforeOnChange) {
            selections = await this.loadSelectedData(selections);
        }

        // 从setState回调中移出来，解决表格中失焦触发onChange
        let foolDisplay = this.getDisplayOrValue(selections, 'display'),
            foolValue = this.getDisplayOrValue(selections, 'value');

        !isEqual &&
            (this._value = new Map(
                JSON.parse(JSON.stringify(this.state.selectedValues)),
            ));
        //前面的数组中是要执行的函数，后面的参数是传递给执行函数的
        this.run(
            [!isEqual && onChange, !isEqual && extraOnChange],
            selections,
            {
                display: foolDisplay,
                value: foolValue,
            },
            { isDefaultCheckDisableData: this.state.isShowDisabledData },
        );

        this.setState(
            {
                referVal: foolDisplay,
                isMoreButtonShow: false,
            },
            () => {
                // 多选清空之后获取焦点，触发历史记录
                if (this.clearFlag) {
                    // 先失去焦点再获取焦点，保证能触发onFocus
                    // this.referInput && this.referInput.blur();//这样blur之后会触发close事件，2207版本并不会
                    this.referInput && this.referInput.focus();
                    this.clearFlag = false;
                }
            },
        );
    };

    // 获取已选择的数据
    getSelections = (options = {}) => {
        let { cleanIsLeaf = false } = options;
        const { rootNode, queryTreeUrl, isRunWithChildren, idKey } = this.props;
        let { runWithChildren, selectedValues } = this.state;
        const selections = [...selectedValues.values()]
            .filter(
                e =>
                    !(
                        e.refpk === (rootNode.refpk || rootNode[idKey]) ||
                        this.getRowValuesBykey(e, 'virtualRootNote') === true
                    ),
            )
            .map(e => {
                let { children, ...others } = e,
                    final = { ...others };
                if (cleanIsLeaf) {
                    let { isleaf, ..._others } = others;
                    final = { ..._others };
                }

                if (isRunWithChildren && runWithChildren) {
                    final.runWithChildren = runWithChildren;
                    final.queryTreeUrl = queryTreeUrl;
                } else {
                    delete final.runWithChildren;
                    delete final.queryTreeUrl;
                }

                return final;
            });
        return this.filterDisabledData(selections);
    };

    treeFilter = (rows, keyword, findParentNode = true) => {
        let rowMap = new Map(),
            { idKey, rootNode } = this.props,
            rootId = rootNode[idKey];
        // 先筛选出来，不区分大小写
        let codes = ['refname', 'refcode'];
        // let codes = treeConfig.code;
        keyword = keyword.toLowerCase();
        rows = rows.filter(row => {
            for (let field of codes) {
                let fieldValue = this.getDisplayOrValue(
                    row,
                    field,
                ).toLowerCase();
                let res = fieldValue.indexOf(keyword);
                if (res > -1) {
                    row.indexOf = res;
                    row.keylength = fieldValue.length;
                    return true;
                }
            }
            return false;
        });

        // rows = rows.sort((a, b) => a.keylength - b.keylength).sort((a, b) => a.indexOf - b.indexOf);
        // 反查父节点
        //先查询所有的叶子节点，之后再把所有的相关父子节点放到数组中

        let indexMap = {};

        rows.forEach((node, index) => {
            indexMap[node[idKey]] = index;
            let parentNode = this.findParent(node);
            let mapKey;
            if (parentNode && node.isleaf) {
                mapKey = node[idKey] + parentNode[idKey];
            } else {
                mapKey = node[idKey];
            }
            !rowMap.has(mapKey) && rowMap.set(mapKey, node);
            if (findParentNode) {
                while (parentNode) {
                    if (!rowMap.has(parentNode[idKey])) {
                        rowMap.set(parentNode[idKey], parentNode);
                        parentNode = this.findParent(parentNode);
                    } else {
                        break;
                    }
                }
            }
        });
        // 除去根节点
        rowMap.delete(rootId);
        return [...rowMap.values()].sort(
            (a, b) => indexMap[a[idKey]] - indexMap[b[idKey]],
        );
    };

    findParent = node => {
        let keyMap = this.originKeyMap,
            { pidKey } = this.props;
        return keyMap[node[pidKey]];
    };

    handlePaste = text => {
        let { refType, searchDataSize, rootNode, onPaste } = this.props;

        if (!onPaste || !/[,，]/.test(text)) {
            return;
        }

        if (refType === 'tree') {
            let data = this.loadTreeDataSync(
                this.__getParam({ pageInfo: { pageIndex: -1 } }),
            );
            this.setTreeData('treeData', rootNode, data);
        }
        // 后台不支持同时中英文逗号
        let keyword = text.replace(/[,，]/g, ','),
            keywords = text.split(','),
            param = this.__getParam({ keyword }),
            { checkStrictly, fieldDisplayed, fieldValued } = this.props,
            results = [],
            codes = this.getSearchConfigCodes(true);

        // 加一条来判断是否还有更多数据
        param.pageInfo = {
            pageSize:
                keywords.length > 1
                    ? keywords.length
                    : Number(searchDataSize) + 1,
            pageIndex: 0,
        };
        let data = (
            refType === 'tree' ? this.loadTreeDataSync : this.loadTableDataSync
        )(param, true, false);

        keywords.map(keyword => {
            let matchedRow = data.rows.find(row =>
                codes.some(
                    field => keyword === this.getDisplayOrValue(row, field),
                ),
            );
            if (matchedRow) {
                results.push(matchedRow);
            } else if (!checkStrictly) {
                // 非严格检查
                results.push({
                    refname: keyword,
                    refcode: keyword,
                    refpk: keyword,
                    [fieldDisplayed]: keyword,
                    [fieldValued]: keyword,
                });
            } else {
                results.push({
                    refname: '',
                    refcode: '',
                    refpk: '',
                    [fieldDisplayed]: '',
                    [fieldValued]: '',
                });
            }
        });

        onPaste(
            results,
            results.map(result => ({
                display: this.getDisplayOrValue(result, 'display'),
                value: this.getDisplayOrValue(result, 'value'),
            })),
            keywords,
        );
    };

    // 搜索的请求--搜索的时候重置表格数据tableData
    dropDownSearch = () => {
        let that = this,
            { refType, searchDataSize, rootNode, useExtraTreeData } =
                this.props,
            { referVal, searchHasMoreData, tableData, collectUsualData } =
                this.state,
            param;

        //查常用，更新常用数据，才能显示搜索结果下拉面板已经收藏的“星标”
        // this.loadUsualData().then((data) => {
        //     if (data.rows.length) {
        //         // 有常用--更新下拉面板常用数据
        //         data.rows.forEach((e) => {
        //             this.toggleValueForMapOrObject(
        //                 collectUsualData,
        //                 e.refpk,
        //                 e
        //             );
        //         });

        //         this.setState({ collectUsualData });
        //     }
        // });

        if (refType === 'tree' && !useExtraTreeData) {
            let data = this.loadTreeDataSync(
                this.__getParam({ pageInfo: { pageIndex: -1 } }),
            );
            this.setTreeData('treeData', rootNode, data);
        }
        // 后台不支持同时中英文逗号
        let keywords = referVal.split(/,|，/);
        let keyword = keywords.join(',');
        param = this.__getParam({ keyword });

        // 加一条来判断是否还有更多数据
        // if (refType !== 'tree') {
        param.pageInfo = {
            pageSize:
                keywords.length > 1
                    ? keywords.length
                    : Number(searchDataSize) + 1,
            pageIndex: -1,
        };
        // }
        (refType === 'tree' ? this.loadTreeData : this.loadTableData)(
            param,
            true,
            false,
        ).then(data => {
            this.enterKeybord = true;

            if (referVal === this.state.referVal) {
                // 查询发起时的keyword和查询结束时的keyword相同时才渲染
                // 树型参照走前端筛选（没必要前端筛选）
                // 懒加载的树走后台
                // refType === 'tree' &&
                // 	!isTreelazyLoad &&
                // 	(data.rows = this.treeFilter(data.rows, referVal, false));
                let { dropDownList } = that.state;
                if (refType === 'tree') {
                    dropDownList.rows = data.rows
                        ? data.rows.filter(e => {
                            return !this.getRowValuesBykey(
                                e,
                                'virtualRootNote',
                            );
                        })
                        : [];
                } else {
                    dropDownList.rows = data.rows;
                }
                if (data.rows && data.rows[searchDataSize]) {
                    searchHasMoreData = true;
                }
                that.setState({
                    dropDownList,
                    searchHasMoreData,
                    loading: false,
                    tableData: [dropDownList], //转换为tableData格式
                });
            }
        });
    };

    // 获取搜索设置为true的字段
    getSearchConfigCodes = (flag = false) => {
        let columnConfig =
                typeof this.getColumnConfig === 'function'
                    ? this.getColumnConfig()[0]
                    : {},
            search = columnConfig.search || {},
            codes = [
                ...new Set(Object.keys(search).filter(code => search[code])),
            ];
        flag && codes.push('refname', 'refcode');
        return codes;
    };

    handleBlurEvent = () => {
        if (this.hotKeyClose) {
            // this.hotKeyClose = false;
            return;
        }
        if (this.clearFlag) {
            // this.clearFlag = false;
            return;
        }
        let { isMultiSelectedEnabled, onBlur } = this.props;
        let selections = this.getSelections();
        !isMultiSelectedEnabled && (selections = selections[0] || {});
        // isMultiSelectedEnabled && (selections = selections[0] || {});z
        // onBlur = null;

        let foolDisplay = this.getDisplayOrValue(selections, 'display'),
            foolValue = this.getDisplayOrValue(selections, 'value');
        this.run([onBlur], selections, {
            display: foolDisplay,
            value: foolValue,
        });
    };

    showCodeIfPossible = value => {
        let { showCodeWhenFocus, fieldValued } = this.props;
        return (
            (showCodeWhenFocus &&
                fieldValued === 'refpk' &&
                !(
                    this.getDisplayOrValue(value, 'refcode').indexOf(',') === 0
                ) &&
                this.getDisplayOrValue(value, 'refcode')) ||
            this.getDisplayOrValue(value, 'display')
        );
    };

    // 失去焦点的事件
    blur = () => {
        this.focusFlag = false;

        let { selectedValues, referVal, dropDownList } = this.state,
            {
                isMultiSelectedEnabled,
                checkStrictly,
                fieldDisplayed,
                fieldValued,
                fieldSplitSep,
                isBlurSearch,
                refType,
            } = this.props,
            { isHistoryStatus, isSelectedStatus, isShowStatus } =
                this.getStatus();
        if (isShowStatus) {
            return false;
        }
        if (this.props.refValueTrim) {
            referVal = referVal.trim();
        }
        if (isHistoryStatus) {
            // 历史记录--历史记录不用单击收起下拉框了
            // selectedValues.clear();
            isMultiSelectedEnabled ? this.multiSelect() : this.singleSelect({});
        } else if (isSelectedStatus) {
            isMultiSelectedEnabled ? this.multiSelect() : this.singleSelect();
        } else {
            // isSearchStatus
            let codes = this.getSearchConfigCodes(true);
            if (
                codes.some(
                    field =>
                        referVal ===
                        this.getDisplayOrValue(
                            [...selectedValues.values()],
                            field,
                        ),
                ) ||
                this.showCodeIfPossible([...selectedValues.values()]) ===
                    referVal
            ) {
                isMultiSelectedEnabled
                    ? this.multiSelect()
                    : this.singleSelect();
            } else {
                let paramKeyword = referVal;
                if (isBlurSearch) {
                    let pageSize = 20;
                    if (isMultiSelectedEnabled && /,|，/.test(referVal)) {
                        // 多选时搜索条数要大于关键字个数
                        pageSize = referVal.split(/,|，/).length + 20;
                    }

                    if (fieldDisplayed.includes(fieldSplitSep)) {
                        let fieldDis = fieldDisplayed.split(fieldSplitSep);
                        let flag = false;
                        paramKeyword = paramKeyword.split(fieldSplitSep);
                        fieldDis.forEach((e, i) => {
                            if (e === 'refcode') {
                                paramKeyword = paramKeyword[i];
                                flag = true;
                            }
                        });
                        if (!flag) {
                            paramKeyword = paramKeyword[0];
                        }
                    }
                    
                    let param = this.__getParam({
                        keyword: paramKeyword,
                        // 后端数据无法根据关键字排序，导致完全匹配的可能在分页外，故调大pageSize，解决大部分场景
                        pageInfo: { pageSize, pageIndex: 0 },
                    });

                    let data = (
                        refType === 'tree'
                            ? this.loadTreeDataSync
                            : this.loadTableDataSync
                    )(param, true, true, true);

                    if (
                        referVal ===
                        (this.props.refValueTrim
                            ? this.state.referVal.trim()
                            : this.state.referVal)
                    ) {
                        //历史遗留问题，blur的时候搜索结果不返回，这里会报错
                        if (!data) {
                            dropDownList.rows = [];
                        } else {
                            dropDownList.rows = data.rows;
                        }
                    }
                }
                // 搜索状态
                // 是否与搜索结果某一项完全匹配
                selectedValues.clear();
                let rowsOfDropDownList =
                    this.filterDisabledData(dropDownList.rows) || [];
                if (isMultiSelectedEnabled && /,|，/.test(referVal)) {
                    // 含逗号多个搜索
                    let keywords = [...new Set(referVal.split(/,|，/))];
                    keywords.map(keyword => {
                        let matchedRow = rowsOfDropDownList.find(row =>
                            codes.some(
                                field =>
                                    keyword ===
                                    this.getDisplayOrValue(row, field),
                            ),
                        );
                        if (matchedRow) {
                            selectedValues.set(matchedRow.refpk, matchedRow);
                        } else if (!checkStrictly) {
                            // 非严格检查
                            selectedValues.set(keyword, {
                                refname: keyword,
                                refcode: keyword,
                                refpk: keyword,
                                [fieldDisplayed]: keyword,
                                [fieldValued]: keyword,
                            });
                        }
                        return keyword;
                    });
                    this.multiSelect();
                } else {
                    // 不含逗号单个搜索
                    let results =
                            Array.isArray(rowsOfDropDownList) &&
                            rowsOfDropDownList.filter(row =>
                                codes.some(
                                    field =>
                                        this.getDisplayOrValue(row, field) ===
                                        referVal || this.getDisplayOrValue(row, field) === paramKeyword,
                                ),
                            ),
                        item = results.length >= 1 ? results : null;
                    if (item && isBlurSearch) { // 不查全量，完全匹配也没啥意义
                        // 完全匹配
                        if (isMultiSelectedEnabled) {
                            item.forEach(element =>
                                selectedValues.set(element.refpk, element),
                            );
                            this.multiSelect();
                        } else {
                            this.singleSelect(item[0]);
                        }
                    } else if (checkStrictly) {
                        // 严格检查
                        selectedValues.clear();
                        isMultiSelectedEnabled
                            ? this.multiSelect()
                            : this.singleSelect({});
                    } else {
                        // 非严格检查
                        let item = {};

                        if (fieldDisplayed.includes(fieldSplitSep)) {
                            fieldDisplayed =
                                fieldDisplayed.split(fieldSplitSep);
                        }
                        Array.isArray(fieldDisplayed)
                            ? fieldDisplayed.forEach(e => {
                                item[e] = referVal;
                            })
                            : (item[fieldDisplayed] = referVal);

                        Array.isArray(fieldValued)
                            ? fieldValued.forEach(e => {
                                item[e] = referVal;
                            })
                            : (item[fieldValued] = referVal);

                        isMultiSelectedEnabled
                            ? (!selectedValues.size &&
                                  selectedValues.set(item.refpk, item),
                            this.multiSelect())
                            : this.singleSelect(item);
                    }
                }
            }
        }

        this.handleBlurEvent();
        this.setState({
            isShow: isShowStatus,
            dropDownShow: false,
            isSelectedShow: false,
            multiSearch: false,
            loading: false,
            showHistoryFlag: false,
            showDropDownTable: false,
        });
    };

    // 获取参照当前的打开状态
    getStatus = () => {
        let isHistoryStatus,
            isSearchStatus,
            isSelectedStatus,
            isShowStatus,
            isFocusStatus,
            isUsualStatus,
            isEdit,
            {
                dropDownShow,
                isSelectedShow,
                referVal,
                isShow,
                activeKey,
                showHistoryFlag,
            } = this.state;
        let { showHistory, renderInTable, isShowSelected, refType } =
            this.props;
        // isHistoryStatus = !!(dropDownShow && !referVal);
        //历史记录待选状态下，传过来的参数showHistoryFlag(true),双击的时候置为false,这个参数在失焦的时候设置为false
        //解决未把flag置为false，一直显示“历史记录”下拉问题
        // if (!referVal) {
        //     showHistoryFlag = false;
        // }
        if (showHistoryFlag) {
            isHistoryStatus = showHistoryFlag ? true : false;
        } else {
            isHistoryStatus = !!(dropDownShow && !referVal);
        }

        if (renderInTable) {
            isHistoryStatus =
                showHistory &&
                isHistoryStatus &&
                this.state.historySelectionVisible;
            // if (isHistoryStatus) {
            //     this.setState({
            //         showDropDownTable: true,
            //     });
            // }
        } else {
            isHistoryStatus = showHistory && isHistoryStatus;
        }
        isSearchStatus =
            !showHistoryFlag &&
            !!(dropDownShow && referVal) &&
            !this.focusFromPopoverBlur &&
            !isSelectedShow;
        isSelectedStatus =
            isShowSelected &&
            !isHistoryStatus &&
            !isSearchStatus &&
            isSelectedShow;
        isShowStatus =
            isShow &&
            (this.popWindow === null ||
                this.popWindow === (this.getTopWindow() || null));
        
        // 传入clickContainer时不获取焦点
        isFocusStatus = this.focusFlag && !isShow && !this.props.clickContainer;
        isEdit = isHistoryStatus || isSearchStatus || isSelectedStatus;
        isUsualStatus = isShowStatus && activeKey === '2';

        return {
            isHistoryStatus,
            isSearchStatus,
            isSelectedStatus,
            isShowStatus,
            isFocusStatus,
            isEdit,
            isUsualStatus,
        };
    };

    // 兼容旧版的数据结构
    updateHistory = history => {
        return history
            .map(e => (e && typeof e === 'object' ? e.refpk : e))
            .filter(e => e);
    };

    // 存入localStorage
    pushToLocal = (item, key = 'referHistory') => {
        // 一个或多个
        let isArray = Array.isArray(item),
            {
                hotDataSize,
                queryGridUrl,
                queryTreeUrl,
                refCode = '',
            } = this.props,
            historyKey = queryGridUrl + queryTreeUrl + refCode,
            ReferHistory = this.getStorage(key),
            history = ReferHistory[historyKey] || [];
        history = this.updateHistory(history);
        // 去除重复的
        for (let i = history.length - 1; i >= 0; i--) {
            let flag = isArray
                ? item.find(e => history[i] === e.refpk)
                : history[i] === item.refpk;
            flag && history.splice(i, 1);
        }
        // 添加新的

        isArray
            ? history.unshift(...item.map(e => e.refpk).reverse())
            : history.unshift(item.refpk);
        if (history.length > hotDataSize) {
            history = history.slice(0, hotDataSize);
        }
        ReferHistory[historyKey] = [...new Set(history)];
        this.setStorage(key, JSON.stringify(ReferHistory));
    };

    // 格式转化：localStorage => list
    localToList = (key = 'referHistory') => {
        let { queryGridUrl, queryTreeUrl, refCode = '' } = this.props,
            historyKey = queryGridUrl + queryTreeUrl + refCode,
            history =
                JSON.parse(getGlobalStorage('localStorage', key) || '{}')[
                    historyKey
                ] || [];

        return this.updateHistory(history);
    };

    handleInputClick = (historySelectionVisible = true, clickInTable) => {
        let {
                disabled,
                showHistory,
                isMultiSelectedEnabled,
                type,
                refType,
                isShowUsual,
                isShowSelected,
                isShowSearch,
                renderInTable,
            } = this.props,
            { isShow, referVal, selectedValues, collectUsualData } = this.state;

        let {
            isHistoryStatus,
            isSearchStatus,
            isSelectedStatus,
            isFocusStatus,
        } = this.getStatus(); //判断当前是否是历史记录状态，如果是下拉面板不打开
        console.log(isHistoryStatus, showHistory, isSelectedStatus);

        if (isShow || disabled) {
            // isShow兼容DropDownRefer
            return false;
        }

        if (type === 'dropDown' && refType === 'grid') {
            console.log('下拉参照');
        } else {
            if (isShowUsual) {
                this.loadUsualData().then(data => {
                    if (data.rows.length) {
                        // 有常用--更新下拉面板常用数据
                        data.rows.forEach(e => {
                            collectUsualData.set(e.refpk, e);
                        });

                        this.setState({ collectUsualData });
                    }
                });
            }
        }

        //满足UI的需求，fc
        let columnConfigWidth = this.getColumnConfigWidthBase();
        if (type === 'dropDown' && refType === 'grid') {
            if (JSON.stringify(columnConfigWidth) !== '{}' && this.Child) {
                // this.Child.resetColumnConfigWidth(); //为什么要在这reset呢，不懂
                let othersColumnConfig = this.Child.getDropColumns(false, true);

                if (
                    Object.keys(columnConfigWidth).length -
                        this.funColumnNum() >
                    othersColumnConfig.length
                ) {
                    let a = Object.keys(columnConfigWidth);
                    let othersColumnKeys = [];
                    othersColumnConfig.forEach(e => {
                        othersColumnKeys.push(e.key);
                    });

                    a.forEach((e, i) => {
                        // console.log(e);
                        if (
                            !othersColumnKeys.includes(e) &&
                            e !== '__checkbox__' &&
                            e !== '__index__' &&
                            e !== '__opt__'
                        ) {
                            columnConfigWidth[e] = 0;
                            delete columnConfigWidth[e];
                        }
                    });
                    this.pushAdjustColumnConfigWidth(columnConfigWidth);
                } else if (
                    Object.keys(columnConfigWidth).length -
                        this.funColumnNum() <
                    othersColumnConfig.length
                ) {
                    //在columnConfigWidth找出来othersColumnConfig中没有的值，置为80
                    for (let e of othersColumnConfig) {
                        if (!Object.keys(columnConfigWidth).includes(e.key)) {
                            columnConfigWidth[e.key] = 80;
                        }
                    }
                    this.pushAdjustColumnConfigWidth(columnConfigWidth);
                }
            }
        } else {
            if (renderInTable) {
                setTimeout(() => {
                    if (
                        JSON.stringify(columnConfigWidth) !== '{}' &&
                        this.Child
                    ) {
                        let othersColumnConfig =
                            this.Child.getDropCommonColumns(false, true);

                        if (
                            Object.keys(columnConfigWidth).length -
                                this.funColumnNum() >
                            othersColumnConfig.length
                        ) {
                            let a = Object.keys(columnConfigWidth);
                            let othersColumnKeys = [];
                            othersColumnConfig.forEach(e => {
                                othersColumnKeys.push(e.key);
                            });

                            a.forEach((e, i) => {
                                // console.log(e);
                                if (
                                    !othersColumnKeys.includes(e) &&
                                    e !== '__checkbox__' &&
                                    e !== '__index__' &&
                                    e !== '__opt__'
                                ) {
                                    columnConfigWidth[e] = 0;
                                    delete columnConfigWidth[e];
                                }
                            });
                            this.pushAdjustColumnConfigWidth(columnConfigWidth);
                        } else if (
                            Object.keys(columnConfigWidth).length -
                                this.funColumnNum() <
                            othersColumnConfig.length
                        ) {
                            //在columnConfigWidth找出来othersColumnConfig中没有的值，置为80
                            for (let e of othersColumnConfig) {
                                if (
                                    !Object.keys(columnConfigWidth).includes(
                                        e.key,
                                    )
                                ) {
                                    columnConfigWidth[e.key] = 80;
                                }
                            }
                            this.pushAdjustColumnConfigWidth(columnConfigWidth);
                        }
                    }
                }, 0);
            } else {
                if (JSON.stringify(columnConfigWidth) !== '{}' && this.Child) {
                    let othersColumnConfig = this.Child.getDropCommonColumns(
                        false,
                        true,
                    );

                    if (
                        Object.keys(columnConfigWidth).length -
                            this.funColumnNum() >
                        othersColumnConfig.length
                    ) {
                        let a = Object.keys(columnConfigWidth);
                        let othersColumnKeys = [];
                        othersColumnConfig.forEach(e => {
                            othersColumnKeys.push(e.key);
                        });

                        a.forEach((e, i) => {
                            // console.log(e);
                            if (
                                !othersColumnKeys.includes(e) &&
                                e !== '__checkbox__' &&
                                e !== '__index__' &&
                                e !== '__opt__'
                            ) {
                                columnConfigWidth[e] = 0;
                                delete columnConfigWidth[e];
                            }
                        });
                        this.pushAdjustColumnConfigWidth(columnConfigWidth);
                    } else if (
                        Object.keys(columnConfigWidth).length -
                            this.funColumnNum() <
                        othersColumnConfig.length
                    ) {
                        //在columnConfigWidth找出来othersColumnConfig中没有的值，置为80
                        for (let e of othersColumnConfig) {
                            if (
                                !Object.keys(columnConfigWidth).includes(e.key)
                            ) {
                                columnConfigWidth[e.key] = 80;
                            }
                        }
                        this.pushAdjustColumnConfigWidth(columnConfigWidth);
                    }
                }
            }
        }

        let trueValue = [...(this._value || new Map()).values()];

        if (trueValue.length) {
            if (isMultiSelectedEnabled) {
                this.handleSelected();
                // 更新下拉面板已选数据

                // let newTableDate = [
                //     {
                //         rows: [...selectedValues.values()],
                //         page: {
                //             pageIndex: 0,
                //             totalPage: 1,
                //         },
                //     },
                // ];
                // this.setState({ tableData: newTableDate });
            } else {
                return;
                // this.handleHideDropTable();
                // this.handleSelected();
                // // 更新下拉面板已选数据
                // let newTableDate = [
                //     {
                //         rows: [...selectedValues.values()],
                //         page: {
                //             pageIndex: 0,
                //             totalPage: 1,
                //         },
                //     },
                // ];
                // this.setState({
                //     tableData: newTableDate,
                // });
            }
        } else if (showHistory && !referVal && this.getDropActiveKey() != 2) {
            this.handleHistory(true, undefined, clickInTable); //该参数用于控制当点击x有弹窗时，不显示下拉面板，再次点击参照时要显示下拉面板
        } else if (this.getDropActiveKey() == 2) {
            let loadDropUsualFlag = true;
            let DropDownShowCertain = true;
            this.handleHistory(
                DropDownShowCertain,
                loadDropUsualFlag,
                clickInTable,
            );
            this.checkUsual(false, true);
        }

        this.setState({
            // 变为编辑态，点击input时，历史记录能显示出来
            historySelectionVisible: historySelectionVisible,
            HistoryDeleteFlag: false, //避免下次进入历史记录直接删除一个值
            searchDeleteFlag: false,
        });
        // showHistory ||
        // (isShowSearch) ||
        // (isShowSelected )
    };

    // 输入框焦点事件
    handleFocus = () => {
        if (
            !(
                this.referInput &&
                this.referInput.contains(document.activeElement)
            )
        ) {
            // 触发这个事件的时候，焦点已不再当前input中了，就不继续执行了
            return;
        }
        this.focusFlag = true;
        // return也可以触发更新然后获取焦点边框
        this.forceUpdate();
        let { disabled } = this.props,
            { isShow } = this.state;
        if (isShow || disabled) {
            // isShow兼容DropDownRefer
            return false;
        }
        if (this.hotKeyClose) {
            // 快捷键关闭时，获取焦点，但是不触发事件
            this.hotKeyClose = false;
            return;
        }

        this.autoFocus = false;
        this.focusFromPopoverBlur = false;
    };

    // 输入框输入事件
    handleInput = (referVal, { searchNow = true, callback } = {}) => {
        //只要一输入字体，让历史记录显示标志置为false
        //如果已选择且输入框长度发生变化，则置为false
        let { selectedValues } = this.state;
        if (referVal !== '') {
            let splitReferVal = referVal.split(',');
            let selectedRefcode = [];

            for (let val of selectedValues.values()) {
                val && selectedRefcode.push(val['refcode']);
            }

            let showSearchFlag = splitReferVal.every(item => {
                return selectedRefcode.includes(item);
            });

            if (!showSearchFlag) {
                this.setState({ showHistoryFlag: false });
            }
        } else {
            // this.setState({
            //     showHistoryFlag: true,
            // });
        }

        // if (referVal.length === 1) {
        //     this.setState({
        //         showHistoryFlag: false,
        //     });
        // }

        this.Akey = this.getDropActiveKey();
        // 只要触发输入就清空已选值，之后失焦的时候再触发选中逻辑
        this.setState(
            {
                referVal,
                selectedValues: new Map(),
                historySelectionVisible: this.props.renderInTable
                    ? false
                    : true,
            },
            () => {
                if (this.state.referVal && searchNow && this.props.inputSearch) {
                    this.handleSearch();
                } else if (this.state.referVal && !this.props.inputSearch) {
                    // inputSearch为false时，输入框有值不显示搜索结果下拉
                    this.setState({ dropDownShow: false });
                } else if (
                    !this.state.referVal &&
                    this.props.showHistory &&
                    this.Akey != 2
                ) {
                    if (this.props.renderInTable) {
                        // this.handleHistory(true, undefined, false); //页签为非常用时启动搜索
                        this.setState({
                            dropDownShow: true,
                            isSelectedShow: false,
                            showDropDownTable: false,
                        });
                    } else {
                        this.handleHistory(); //页签为非常用时启动搜索
                    }
                } else if (this.Akey == 2) {
                    let loadDropUsualFlag = true;
                    let DropDownShowCertain = true;
                    this.handleHistory(DropDownShowCertain, loadDropUsualFlag);
                    this.checkUsual(false, true);
                }

                // 状态更新完成后执行回调
                if (typeof callback === 'function') {
                    callback();
                }
            },
        );
    };
    //清空的时候正常是要显示历史记录，但是会存在业务在编辑后赋值，这个时候应改显示已选
    handleHistory = (DropDownShowCertain, loadDropUsual, clickInTable) => {
        let {
                queryGridUrl,
                refType,
                hotDataSize,
                useHistoryCache,
                pageSize,
                showHistory,
                useExtraTreeData,
                renderInTable,
            } = this.props,
            { dropDownList, referVal, tableData } = this.state;
        // 没值历史记录
        let history = this.localToList('referHistory');
        if (history.length) {
            let param = this.__getParam({
                pageInfo: { pageSize: hotDataSize },
                searchPks: history,
                isHistory: true,
            });
            if (refType === 'tree' && !useExtraTreeData) {
                this.loadTreeData(param, true, false).then(data => {
                    this.enterKeybord = true;
                    if (!referVal) {
                        data.rows = this.sortRowsByPk(data.rows, history, true);
                        if (data.page) {
                            data.page = {
                                pageIndex: 0,
                                pageSize: pageSize || 50,
                                totalPage: 1,
                            };
                        }

                        this.setState({
                            loading: false,
                            dropDownList: data,
                            tableData: [data], //转换为tableData格式
                        });
                    }
                });
            } else if (queryGridUrl && loadDropUsual !== true) {
                this.loadTableData(param, useHistoryCache, false).then(
                    data => {
                        this.enterKeybord = true;
                        if (!referVal) {
                            data.rows = this.sortRowsByPk(
                                data.rows,
                                history,
                                true,
                            );
                            if (data.page) {
                                data.page = tableData?.[0]?.page || {
                                    pageIndex: 0,
                                    pageSize: pageSize || 50,
                                    totalPage: 1,
                                };
                            }
                            this.setState({
                                loading: false,
                                dropDownList: data,
                                tableData: [data], //转换为tableData格式
                            });
                        }
                    },
                );
            }
        } else {
            // dropDownList.rows = [];
            // this.setState({
            //     loading: false,
            //     dropDownList,
            // });
            this.setState({
                loading: false,
                tableData: [
                    {
                        rows: [],
                        page: tableData?.[0]?.page || {
                            pageIndex: 0,
                            pageSize: pageSize || 50,
                            totalPage: 1,
                        },
                    },
                ],
            });
        }

        if (loadDropUsual === false) {
            this.loadHistoryData(); //加载历史记录并展示为下拉表格的形式
        }

        if (DropDownShowCertain) {
            this.setState({
                dropDownShow: true,
                isSelectedShow: false,
                showDropDownTable: showHistory
                    ? renderInTable && !clickInTable
                        ? false
                        : true
                    : false,
            });
        } else {
            if (this.props.isShowPrompt) {
                this.setState({
                    // dropDownShow: true,
                    dropDownShow: false,
                    isSelectedShow: false,
                });
            } else {
                this.setState({
                    dropDownShow: true,
                    isSelectedShow: false,
                    showDropDownTable: showHistory ? true : false,
                });
            }
        }
    };

    handleSearch = () => {
        let {
                inputDefer,
                isMultiSelectedEnabled,
                type,
                refType,
                isShowSearch,
            } = this.props,
            { dropDownList, referVal } = this.state;
        dropDownList.rows = [];
        this.interval = new Date().getTime();
        this.enterKeybord = false;
        let s = setTimeout(() => {
            // 停止输入0.5s后执行
            if (new Date().getTime() - this.interval >= inputDefer) {
                if (this.state.referVal) {
                    this.state.dropDownList.rows = [];
                    this.dropDownSearch();
                }
            }
            clearTimeout(s);
        }, inputDefer);
        // //多选输入的时候先不打开下拉面板
        // if (!isMultiSelectedEnabled) {
        //     this.setState({
        //         showDropDownTable: true,
        //     });
        // }
        if (
            (isMultiSelectedEnabled && /,|，/.test(referVal)) ||
            !isShowSearch
        ) {
            this.setState({ showDropDownTable: false });
        } else {
            this.setState({ showDropDownTable: true });
        }
        if (type === 'dropDown' && refType === 'grid') {
            this.setState({ isShow: false });
        }

        this.setState({
            // showDropDownTable: true,
            dropDownShow: true,
            isSelectedShow: false,
            multiSearch: isMultiSelectedEnabled && /,|，/.test(referVal), //控制多选状态下搜索“value,value”，不显示下拉
        });
    };

    handleSelected = () => {
        //查常用，更新常用数据，才能显示已选下拉面板已经收藏的“星标”
        // let { collectUsualData } = this.state;
        // this.loadUsualData().then((data) => {
        //     if (data.rows.length) {
        //         // 有常用--更新下拉面板常用数据
        //         data.rows.forEach((e) => {
        //             this.toggleValueForMapOrObject(
        //                 collectUsualData,
        //                 e.refpk,
        //                 e
        //             );
        //         });

        //         this.setState({ collectUsualData });
        //     }
        // });
        if (!this.props.isShowSelected) {
            this.setState({ showDropDownTable: false });
        } else {
            this.setState({ showDropDownTable: true });
        }

        this.setState({
            dropDownShow: false,
            isSelectedShow: this.props.isShowSelected ? true : false,
        });
    };

    // 点击参照以外的区域收起下拉
    close = noDelay => {
        // 客户用快捷键切到其他应用查看数据时，下拉面板不应收起，保证操作连续性
        // window blur 监听为主，document.hasFocus() 同步兜底（应对 element blur 早于 window blur 的时序）
        // 解决：YBP-S-882088
        if (this.windowBlurred || !document.hasFocus()) {
            return;
        }
        // let el = window.document.body; //声明一个变量，默认值为body
        // window.document.body.onmouseover = function (event) {
        //     el = event.target; //鼠标每经过一个元素，就把该元素赋值给变量el
        //     console.log('当前鼠标在', el, '元素上'); //在控制台中打印该变量
        // };
        // if (cursorStyle === '') console.log(document.activeElement);

        // 拖动下拉面板内表格列宽时不收起面板，面板外才收起
        if (this.cursorStyle === 'col-resize') {
            const childNode = this.Child && ReactDOM.findDOMNode(this.Child);
            if (childNode && this.lastMoveTarget && childNode.contains(this.lastMoveTarget)) {
                return; // 鼠标在下拉面板内，不关闭
            }
        }

        //判断是否存在元素
        if (
            // document.body.contains(
            //     document.querySelector('.floatWriteFloatModal')
            // ) ||
            document.body.contains(
                document.querySelector('.lightbq-plugin-modal-body'),
            ) //表格中的blur状态还是得保留
        ) {
            if (this.cursorStyle === undefined) {
                this.cursorStyle = 'auto';
            }

            if (this.cursorStyle === 'col-resize') {
                //应该修改这里，如果是参照的下拉面板内拖动表格列宽，就不收起下拉面板，如果是下拉面板外拖动表格列宽，才收起下拉面板
                this.cursorStyle = undefined;
            }
        }
        let colResizeFlag;

        if (this.cursorStyle === 'col-resize') {
            this.cursorStyle = 'auto';
            colResizeFlag = true;
        }

        // console.log(this.cursorStyle);

        if (
            document.activeElement.localName === 'body' &&
            this.cursorStyle !== 'auto'
        ) {
            //再加个cursor已触发x后的下拉面板收起
            if (
                this.cursorStyle === 'default' ||
                this.cursorStyle === 'text' ||
                this.cursorStyle === 'move' ||
                this.cursorStyle === 'pointer' ||
                this.cursorStyle === 'all-scroll' ||
                this.cursorStyle === 'not-allowed' ||
                (!colResizeFlag && this.cursorStyle === undefined)
            ) {
                console.log('default/text');
            } else {
                return;
            }
        }

        //下拉面板关闭时，横向滚动条回正
        setTimeout(() => {
            if (
                this.Child &&
                this.Child.dropscrolltable &&
                this.Child.dropscrolltable.scrollLeft > 0
            ) {
                this.Child.dropscrolltable.scrollLeft = 0;
            }

            //关闭弹窗再次打开的时候，滚动条位置回正
            //切换为新下拉面板时注意添加该逻辑
            // if (
            //     this.props.type === 'dropDown' &&
            //     this.props.refType === 'grid'
            // ) {
            //     console.log('下拉参照');
            // } else {
            //     let referdroptable = 'refer-drop-' + this.props.attrcode;
            //     let element =
            //         document.getElementsByClassName(referdroptable)[0];
            //     if (element) {
            //         let flexRight = element.querySelector(
            //             '.wui-table-fixed-right'
            //         );
            //         let tableBodyInnerScroll = flexRight.querySelector(
            //             '.wui-table-body-inner'
            //         );
            //         tableBodyInnerScroll.scrollTop = 0;
            //     }
            // }
        }, 500);

        // 失去焦点校验
        this.setState({ showDropDownTable: false });
        if (this.timerDrop) {
            setTimeout(() => {
                this.blur();
            }, 301);
        } else {
            if (!this.props.isDelayBlur || noDelay) {
                this.blur();
            } else {
                setTimeout(() => {
                    this.blur();
                }, 300); //怕不是有大病，点那么快干嘛，点的过快导致表中行选中逻辑还没执行就走了blur的逻辑
            }

            // this.blur();
        }

        // setTimeout(() => {
        //     this.blur();
        // }, 301);
        // if (!this.state.showDropDownTable) {
        //     if (this.timerDrop) {
        //         setTimeout(() => {
        //             this.blur();
        //         }, 301);
        //     } else {
        //         this.blur();
        //     }
        // }

        if (this.state.isMoreButtonShow) {
            this.setState({ isMoreButtonShow: false });
        }
    };

    // 用快捷键关闭参照时触发的事件
    onHotKeyClose = () => {
        // this.props.onEnter 存在 就不设置 hotKeyClose关闭了
        this.hotKeyClose = !this.props.onEnter;
        this.focusFlag = true;
        let timer = setTimeout(() => {
            this.referInput && this.referInput.focus();
            clearTimeout(timer);
        }, 10);
        this.setState({
            dropDownShow: false,
            loading: false,
            isAddButtonShow: false,
        });
        // this.handleHideDropTable();
        // this.handlePopoverBlur();
    };

    // 在参照输入框中删除
    clear = () => {
        this.clearFlag = true;
        const { isMultiSelectedEnabled, disabled, showHistory, renderInTable } =
            this.props;
        if (disabled) {
            return false;
        }
        // this.referInput?.focus();

        // this.state.selectedValues = new Map();
        this.setState(
            {
                selectedValues: new Map(),
                // dropDownShow: true,
                dropDownShow: this.props.isShowPrompt ? false : true,
                isShow: false,
                isSelectedShow: false,
                referVal: '',
                tableData: [{
                    rows: [],
                    page: this.state.tableData[0].page,
                }],
                // tableData 不知道为什么历史记录用tableData的值了，导致值错乱，只能清空的时候清空一下了。
                // renderInTable 让删除完时，历史记录能显示出来
                // historySelectionVisible: true,
                historySelectionVisible: renderInTable ? false : true,
                // showDropDownTable: true,
                showDropDownTable: this.props.showHistory
                    ? renderInTable
                        ? false
                        : true
                    : false,
            },
            () => {
                // this.setState({
                //     showDropDownTable: this.props.showHistory
                //         ? renderInTable
                //             ? false
                //             : true
                //         : false,
                // });
                isMultiSelectedEnabled
                    ? this.multiSelect()
                    : this.singleSelect({}, undefined, true);
                this.referInput?.focus();
                !renderInTable && this.handleInput('');
            },
        );
    };

    // 删除一个值
    delItem = item => {
        let { selectedValues } = this.state;
        selectedValues.delete(item.refpk);
        this.setState({ selectedValues });
    };

    // 选择函数时的点击事件
    onFunctionClick = item => {
        const {
            isMultiSelectedEnabled,
            fieldDisplayed,
            fieldValued,
            fieldSplitSep,
            refType,
        } = this.props;

        let value = {
            refname: item.name,
            refpk: item.code,
        };

        if (item.hasOwnProperty('value')) {
            let param = this.__getParam({
                pageInfo: { pageSize: 1 },
                searchPks: [item.value],
            });

            // 校验函数是否合法
            value.isValid = !!(
                refType === 'tree'
                    ? this.loadTreeDataSync
                    : this.loadTableDataSync
            )(param)?.rows?.length;
        }

        if (fieldDisplayed.includes(fieldSplitSep)) {
            fieldDisplayed.split(fieldSplitSep);
        }

        Array.isArray(fieldDisplayed)
            ? fieldDisplayed.forEach(e => {
                value[e] = item.name;
            })
            : (value[fieldDisplayed] = item.name);

        Array.isArray(fieldValued)
            ? fieldValued.forEach(e => {
                value[e] = item.code;
            })
            : (value[fieldValued] = item.code);
        if (isMultiSelectedEnabled) {
            this.setState(
                { selectedValues: new Map([[item.code, value]]) },
                function () {
                    this.multiSelect();
                },
            );
        } else {
            this.singleSelect(value);
        }
    };

    // 编辑前事件
    beforeEvent = (
        onFocus,
        callback,
        event,
        { fromFocus, fromIconRefer } = {},
    ) => {
        // event && typeof event.stopPropagation === 'function' && event.stopPropagation();
        let {
                isMultiSelectedEnabled,
                onEnter,
                onBeforeFocus,
                onFocusFilterAdd,
            } = this.props,
            { referVal } = this.state;
        if (typeof onBeforeFocus === 'function') {
            onBeforeFocus();
        }
        if (typeof onFocusFilterAdd === 'function') {
            this.setState({ addButtonDropDown: onFocusFilterAdd() });
        }
        if (typeof onFocus === 'function') {
            let res = onFocus(
                isMultiSelectedEnabled
                    ? this.getSelections()
                    : this.getSelections()[0] || {},
                event,
            );
            if (res instanceof Promise) {
                res.then(isContinue => {
                    // 容错undefined
                    if (isContinue !== false) {
                        // Promise异步，导致调用 beforeEvent 和 callback 时的 referVal 可能不一致
                        referVal = this.state.referVal;
                        fromFocus
                            ? this.run(callback, referVal)
                            : this.run(callback);
                    } else {
                        this.referInput && this.referInput.blur();
                        //鼠标点击时不触发onEnter查找下一个焦点的方法
                        this.referInputMouseDown !== true &&
                            fromIconRefer !== true &&
                            onEnter &&
                            onEnter({ e: event });
                    }
                });
            } else if (res !== false) {
                // 容错undefined
                referVal = this.state.referVal;
                fromFocus ? this.run(callback, referVal) : this.run(callback);
            } else {
                this.referInput && this.referInput.blur();

                this.referInputMouseDown !== true &&
                    fromIconRefer !== true &&
                    onEnter &&
                    onEnter({ e: event });
            }
        } else {
            referVal = this.state.referVal;
            fromFocus ? this.run(callback, referVal) : this.run(callback);
        }
        this.setState({ showHistoryFlag: false, //控制下拉历史记录是否已选择完
        });
    };

    // 加载已选数据
    loadSelectedData = (selections, { shouldUpdate = true } = {}) => {
        selections = selections || this.getSelections();
        if (selections.length) {
            const { refType, idKey, checkStrictly } = this.props;
            let param = this.__getParam({
                searchPks: selections.map(e => e['refpk'] || e[idKey]),
                pageInfo: { pageIndex: 0 },
                loadSelectedData: true,
            });
            let data = (
                refType === 'tree'
                    ? this.loadTreeDataSync
                    : this.loadTableDataSync
            )(param, true, true, true);
            if (!data) {
                data = [];
            }

            data.rows = this.sortRowsByPk(
                [...selections, ...data.rows],
                selections.map(e => e['refpk'] || e[idKey]),
                checkStrictly,
            );
            if (shouldUpdate) {
                let selectedValues = new Map(
                    data.rows.map(e => [e[idKey], e]),
                );
                this.setState({ selectedValues, loading: false });
            }
            return data.rows;
        }
    };

    showDropDownByHotKey = () => {
        let { renderInTable, showHistory } = this.props;
        let { referVal } = this.state;
        let { isFocusStatus, isSearchStatus } = this.getStatus();
        // if (renderInTable !== true) return;

        if (renderInTable && isFocusStatus) {
            //在table中渲染的参照需要按ctrl键时打开历史记录
            // this.setState({
            //     historySelectionVisible:
            //         !this.state.historySelectionVisible,
            // })

            //表格中ctrl关闭下拉面板  非搜索结果的情况下
            if (this.state.showDropDownTable && !isSearchStatus) {
                setTimeout(() => {
                    this.setState({ showDropDownTable: false });
                }, 10);
            } else {
                // 触发历史记录或者已选显示
                this.handleInputClick(
                    !this.state.historySelectionVisible,
                    true,
                );
            }
        } else if (isFocusStatus) {
            // this.handleInputClick();
            if (isFocusStatus && !referVal) {
                if (!this.state.showDropDownTable) {
                    this.handleInputClick();
                } else {
                    this.setState({ showDropDownTable: !this.state.showDropDownTable });
                }
                // this.setState({
                //     showDropDownTable: !this.state.showDropDownTable,
                // });
            }
            // isFocusStatus &&
            //     !referVal &&
            //     this.setState({
            //         showDropDownTable: !this.state.showDropDownTable,
            //     });
        }
    };
    //ctrl 键加节流
    throttleShowDropDownByHotKey = debounce(this.showDropDownByHotKey, 300);
    // 绑定快捷键
    bindHotKeys = ({ trueValue }) => {
        let { onFocus, isMultiSelectedEnabled } = this.props,
            { isFocusStatus } = this.getStatus();

        return (
            <HotKeys
                keyMap={{
                    f2: 'f2',
                    del: ['del', 'backspace'],
                    // tab: [
                    // 	'tab',
                    // 	'shift+tab'
                    // ],
                    esc: 'esc',
                    showHistorySelection: 'ctrl',
                }}
                handlers={{
                    f2: () => {
                        if (isFocusStatus) {
                            //快捷键打开参照弹窗的时候，隐藏下拉面板
                            // if (
                            //     this.Child &&
                            //     this.Child.ChildColumn &&
                            //     this.Child.ChildColumn.shezhi &&
                            //     document.body.contains(
                            //         document.querySelector('.coulmn-popover')
                            //     )
                            // ) {
                            //     this.Child.ChildColumn.shezhi.click();
                            // }
                            this.setState(
                                { showDropDownTable: false },
                                () => {
                                    this.show();
                                },
                            );
                        }
                    },
                    del: event => {
                        let { showHistory, renderInTable } = this.props;
                        if (renderInTable) {
                            // 让删除完时，历史记录能显示出来
                            isFocusStatus &&
                                showHistory &&
                                this.setState({ historySelectionVisible: true });
                        }
                        // let { isFocusStatus, isEdit } = this.getStatus();
                        // //参照输入框点击删除按钮判断当前是选中后状态还是输入状态,如果是输入状态，按删除就一个个删，如果是选中后状态就直接全部删除
                        // if (
                        //     isFocusStatus &&
                        // 	trueValue.length > 0 &&
                        // 	isMultiSelectedEnabled &&
                        // 	!isEdit
                        // ) {
                        //     this.beforeEvent(onFocus, this.clear, event);
                        // }
                    },
                    esc: () => {
                        this.setState({
                            dropDownShow: false,
                            isSelectedShow: false,
                            showHistoryFlag: false,
                        });
                        this.handleOnlyHideDropTable();
                    },
                    showHistorySelection: this.throttleShowDropDownByHotKey,
                }}
                attach={document.body}
                focused={true}
            />
        );
    };

    handlePopoverBlur = () => {
        let { needFocusOnClose, renderInTable, onCancel } = this.props;
        this.setState({ isShow: false, selectedShow: false });
        typeof onCancel === 'function' && onCancel();
        if (needFocusOnClose) {
            let needFocusCell = renderInTable && findParentTd(this.referInput);

            // 关闭时自动聚焦到当前文本框  去除自动失去焦点 事件 bbqin
            this.focusFromPopoverBlur = true;
            this.focusFlag = true;
            let timer = setTimeout(() => {
                //弹窗关闭时添加标识，根据这个标识在referInput获取焦点时判断是否需要展示历史搜索记录
                if (this.referInput) {
                    this.referInput.focus();
                } else {
                    let cell =
                        needFocusCell &&
                        needFocusCell.querySelector('div[tabindex="0"]');
                    cell && cell.focus();
                }
                clearTimeout(timer);
            }, 20);
        } else {
            setTimeout(() => {
                this.handleBlurEvent();
            }, 10);
        }
    };

    // 过滤禁用数据
    filterDisabledData = data => {
        let { refType } = this.props;
        if (Array.isArray(data)) {
            return data.filter(e => {
                if (refType === 'tree') {
                    // 排除禁用的节点
                    return !this.isDisabled(e);
                } else {
                    return true;
                }
            });
        } else {
            return [];
        }
    };

    // 数据（树节点）是否被禁用
    isDisabled = item => {
        let { onlyLeafCanSelect, idKey, refType, ignoreLeafDisable, isShowDisabledData } =
                this.props,
            { keyMap } = this.state;
        let isNodeDisabled = item && item.disabled;

        // 从全量数据中找到当前节点，否则isleaf会错乱
        let kItem = keyMap?.[item[idKey]] ?? item;
        let disabled =
            refType === 'tree' &&
            onlyLeafCanSelect &&
            ((ignoreLeafDisable && isNodeDisabled) || (isShowDisabledData ? item.isleaf === false : kItem.isleaf === false));
        if (!disabled && item.values && item.values.ReturnOnTree) {
            disabled =
                item.values.ReturnOnTree.display === 'N' ||
                item.values.ReturnOnTree.value === 'N';
        }
        return disabled;
    };

    //查历史记录数据，也是“最近使用”
    loadHistoryData = () => {
        let { queryGridUrl, hotDataSize, pageSize } = this.props;
        let { collectUsualData } = this.state;
        // 没值历史记录
        let history = this.localToList('referHistory');
        if (history.length) {
            //查常用，更新常用数据，才能显示历史记录下拉面板已经收藏的“星标”

            let param = this.__getParam({
                pageInfo: { pageSize: hotDataSize },
                searchPks: history,
                isHistory: true,
            });
            if (queryGridUrl) {
                this.loadTableData(param, true, false).then(data => {
                    data.rows = this.sortRowsByPk(data.rows, history, true);
                    this.setTableData('tableData', 0, data);
                });
            }
        } else {
            // let data = [{}];
            // data.rows = [];
            // this.setTableData('tableData', 0, data);

            this.setState({
                loading: false,
                tableData: [
                    {
                        rows: [],
                        page: {
                            pageIndex: 0,
                            pageSize: pageSize || 50,
                            totalPage: 1,
                        },
                    },
                ],
            });
        }
    };

    resetFirstSelectedKeys = (keys, refval) => {
        console.log('ss');
        return false;
    };
    // 点击参照三个点的事件
    show = () => {
        return null;
    };

    // 渲染：下拉区
    renderDropDown = () => {
        return null;
    };

    // 渲染：弹出层
    renderPopover = () => {
        return null;
    };

    // 渲染：弹出层头部
    renderPopoverHeader = () => {
        return null;
    };

    // 渲染：弹出层头部扩展区
    renderPopoverHeaderExtend = () => {
        return null;
    };

    // 渲染：弹出层搜索区
    renderPopoverSearchArea = () => {
        return null;
    };

    // 渲染：弹出层搜索区扩展区
    renderPopoverSearchExtendArea = () => {
        return null;
    };

    // 渲染：弹出层容器
    renderPopoverContain = () => {
        return null;
    };

    // 渲染：弹出层容器左侧
    renderPopoverLeft = () => {
        return null;
    };

    // 渲染：弹出层容器左侧上部
    renderPopoverLeftHeader = () => {
        return null;
    };

    // 渲染：弹出层右侧
    renderPopoverRight = () => {
        return null;
    };

    // 渲染：弹出层表格分页区
    renderPopoverPageArea = () => {
        return null;
    };

    // 渲染：弹出层底部
    renderPopoverBottom = () => {
        return null;
    };

    // 渲染：弹出层底部扩展区
    renderPopoverBottomExtend = () => {
        return null;
    };

    test = () => {
        // console.log('supertest');
    };
    handleDropDownTableFlag(flag, unblurfalg) {
        this.setState({
            showDropDownTable: flag,
            unblurfalg: unblurfalg,
        });
    }
    handleColumnConfigWidth() {
        if (this.state.showDropDownTable) {
            console.log('恢复默认点了');
            this.Child && this.Child.resetColumnConfigWidth();
        }
    }

    funColumnNum = () => {
        let { isMultiSelectedEnabled, isShowUsual } = this.props;
        let funColumn;
        if (isMultiSelectedEnabled && isShowUsual) {
            funColumn = 3;
        } else if (isMultiSelectedEnabled || isShowUsual) {
            funColumn = 2;
        } else {
            funColumn = 1;
        }
        return funColumn;
    };

    render() {
        let {
            referVal,
            loading,
            dropDownList,
            selectedValues,
            jsonInsideRefer,
            dropDownShow,
            searchHasMoreData,
            multiSearch,
            isSelectedShow,
            selectedDeleteFlag,
            deleteSelectedData,
            deleteHistoryData,
            HistoryDeleteFlag,
            deleteSearchData,
            searchDeleteFlag,
            tableData,
            showDropDownTable,
            collectUsualData,
            isAddButtonShow,
            addButtonList,
            addButtonDropDown,
            pagPageInfo,
            usePagaPageInfo,
        } = this.state;
        let {
                disabled,
                referClassName,
                className,
                style,
                placeholder,
                dropDownContainer,
                isMultiSelectedEnabled,
                onFocus,
                functions,
                showTitle,
                tabIndex,
                onClick,
                onEnter,
                fieldid,
                attrcode,
                dropDownPlacement,
                dropDownTitleConfig,
                clickContainer,
                hotKeyWithArrow,
                searchDataSize,
                hotDataSize,
                isShowSelected,
                isShowSearch,
                idKey,
                dropdownClassName,
                inputType,
                stopPropagationWhenDropdownPressEnter,
                autoHeight = false,
                fieldValued,
                refType,
                type,
                pageSize,
                queryTreeUrl,
                queryGridUrl,
                hasAddButton,
                refcode,
                isShowUsual,
                dropDownFxContainer,
                tabskip, // tab键跳过
                rowKey,
                defaultDropColumns,
                showClearButton = true,
            } = this.props,
            {
                isHistoryStatus,
                isSearchStatus,
                isSelectedStatus,
                isFocusStatus,
            } = this.getStatus(),
            trueValue = [
                // ...((isSearchStatus && isMultiSelectedEnabled ? selectedValues : this._value) || new Map()).values()
                ...(
                    (isSelectedStatus ||
                    (isSearchStatus && isMultiSelectedEnabled)
                        ? this.getSelections()
                        : this._value) || new Map()
                ).values(),
            ],
            firstLabel = this.getDisplayOrValue(trueValue, 'display'),
            allLabel = trueValue
                .map(e => this.getDisplayOrValue(e, 'display'))
                .join(',');
        dropdownClassName += ' refer-container';
        let _fieldid = getSysFieldid(fieldid || attrcode);
        if (_fieldid) {
            dropdownClassName += ` fieldid_${_fieldid}_refer`;
        }

        let InputElement, inputSelector;
        switch (inputType) {
            case 'input':
                InputElement = FormControl;
                inputSelector = 'input';
                break;
            case 'textarea':
                InputElement = Textarea;
                inputSelector = 'textarea';
                break;
            default:
                InputElement = FormControl;
                inputSelector = 'input';
                break;
        }
        this.prevStatus = isSearchStatus
            ? // 搜索结果
            'isSearchStatus'
            : isHistoryStatus
                ? // 历史记录
                'isHistoryStatus'
                : isSelectedStatus
                    ? // 已选择
                    'isSelectedStatus'
                    : this.prevStatus || '';

        let hasClearButton = showClearButton && !!(isFocusStatus ? referVal : firstLabel);

        return (
            <div
                className={`refer-wrapper clearfix ${
                    disabled ? 'refer-wrapper-disabled' : ''
                }`}
                style={{ display: 'flex' }}
                fieldid={_fieldid}
                ref={dom => {
                    this.refer = dom;
                }}
            >
                {this.bindHotKeys({ trueValue })}
                <Dropdown
                    trigger={['click']}
                    overlayClassName={dropdownClassName}
                    // overlayStyle={{ zIndex: this.props.zIndex }}
                    placement={dropDownPlacement}
                    ref={dom => {
                        this.referContainer = ReactDOM.findDOMNode(dom);
                    }}
                    // delay={1}
                    // delayHide={0.1}
                    // animation="slide-up"
                    // overlayStyle={{
                    //     opacity: showDropDownTable ? '1' : '0',
                    // }}
                    visible={showDropDownTable}
                    onVisibleChange={visible => {
                        if (!visible) {
                            setTimeout(() => {
                                this.prevStatus = '';
                            }, 0);
                        } else {
                            this.Child && this.Child.setDataState({ rowIndex: -1 });
                        }
                    }}
                    overlay={(() => {
                        let columnConfig = dropDownTitleConfig || [
                                {
                                    name: [
                                        jsonInsideRefer[
                                            'containers-refer-0038'
                                        ], // 编码
                                        jsonInsideRefer[
                                            'containers-refer-0039'
                                        ], // 名称
                                    ],
                                    code: ['refcode', 'refname'],
                                },
                            ],
                            data = (
                                this.prevStatus === 'isSelectedStatus'
                                    ? this.getSelections()
                                    : this.filterDisabledData(dropDownList.rows)
                            ).map(item => {
                                let label = columnConfig[
                                    columnConfig.length - 1
                                ].code
                                    .map(
                                        e =>
                                            this.getDisplayOrValue(item, e) ||
                                            '-',
                                    )
                                    .join('/');
                                item.label = label;
                                return item;
                            }),
                            // title = isSearchStatus
                            //     ? // 搜索结果
                            // 	  jsonInsideRefer['containers-refer-0034']
                            //     : isHistoryStatus
                            //         ? // 历史记录
                            // 	  jsonInsideRefer['containers-refer-0035']
                            //         : isSelectedStatus
                            //             ? // 已选择
                            // 	  jsonInsideRefer['containers-refer-0036']
                            //             : '',
                            title =
                                this.prevStatus === 'isSearchStatus'
                                    ? // 搜索结果
                                    jsonInsideRefer['containers-refer-0034']
                                    : this.prevStatus === 'isHistoryStatus'
                                        ? // 历史记录
                                        jsonInsideRefer['containers-refer-0035']
                                        : this.prevStatus === 'isSelectedStatus'
                                            ? // 已选择
                                            jsonInsideRefer['containers-refer-0036']
                                            : '',
                            noData = [
                                this.prevStatus === 'isSearchStatus'
                                    ? // 搜索结果
                                    `“${jsonInsideRefer['containers-refer-0034']}”`
                                    : // 历史记录
                                    `“${jsonInsideRefer['containers-refer-0035']}”`,
                                // 暂无数据
                                <span>
                                    {jsonInsideRefer['containers-refer-0041']}
                                </span>,
                            ],
                            customColumnConfig,
                            footer;

                        //有dropDownTitleConfig属性的下拉表头一行显示
                        if (dropDownTitleConfig) {
                            if (this.props.specialDropShow) {
                                customColumnConfig = {
                                    name: [dropDownTitleConfig[0].name.join('/')],
                                    code: dropDownTitleConfig[0].code,
                                    width: dropDownTitleConfig[0].width
                                };
                                refType = 'tree';
                            } else if (refType === 'tree') {
                                customColumnConfig = {
                                    name: dropDownTitleConfig[0].name,
                                    code: dropDownTitleConfig[0].code,
                                };
                            } 
                        }

                        //在这之前加一个过滤，把disabled的树节点数据过滤掉
                        tableData[0].rows = this.filterDisabledData(
                            tableData[0].rows,
                        );

                        if (isHistoryStatus && this.state.activeKey == '1') {
                            data = data.slice(0, hotDataSize);
                            tableData[0].rows = tableData[0].rows.slice(
                                0,
                                hotDataSize,
                            );
                        } else if (isSearchStatus) {
                            data = data.slice(0, searchDataSize);
                            tableData[0].rows = tableData[0].rows.slice(
                                0,
                                searchDataSize,
                            );
                        } else if (
                            isHistoryStatus &&
                            this.state.activeKey == '2'
                        ) {
                            data = data.slice(0, 100);
                            tableData[0].rows = tableData[0].rows.slice(0, 100);
                        }

                        //有dropDownTitleConfig属性的下拉表格数据
                        // if (dropDownTitleConfig) {
                        //     customColumnConfig = {
                        //         name: [dropDownTitleConfig[0].name.join('')],
                        //         code: [dropDownTitleConfig[0].code],
                        //     };
                        // }

                        if (this.prevStatus === 'isSelectedStatus') {
                            footer = this.prevStatus === 'isSelectedStatus' && (
                                <span className="refer-copy">
                                    {/* 复制 */}
                                    <span
                                        onClick={() => {
                                            this.hiddenInput.select();
                                            document.execCommand('Copy');
                                        }}
                                    >
                                        {
                                            jsonInsideRefer[
                                                'containers-refer-0037'
                                            ]
                                        }
                                    </span>
                                </span>
                            );
                        } else {
                            footer =
                                data.length &&
                                searchHasMoreData &&
                                this.prevStatus === 'isSearchStatus' ? (
                                        <div className="refer-show-more">
                                            <span>
                                                {/* 点击“ */}
                                                {
                                                    jsonInsideRefer[
                                                        'containers-refer-0043'
                                                    ]
                                                }
                                                <span
                                                    className="icon-refer"
                                                    onClick={this.show}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                                {/* ”查看更多 */}
                                                {
                                                    jsonInsideRefer[
                                                        'containers-refer-0044'
                                                    ]
                                                }
                                            </span>
                                        </div>
                                    ) : null;
                        }
                        // console.log('isSearchStatus:'+isSearchStatus,'isSelectedStatus:'+isSelectedStatus,"isHistoryStatus:"+isHistoryStatus,data,title,selectedValues,columnConfig);
                        return (
                            <React.Fragment>
                                {
                                    <DropDownTableRefer
                                        containerDom={this.referContainer}
                                        footer={footer}
                                        attrcode={attrcode}
                                        rowKey={rowKey}
                                        jsonInsideRefer={jsonInsideRefer}
                                        tableData={tableData}
                                        enterKeybord={this.enterKeybord}
                                        selectedValues={selectedValues}
                                        columnConfig={this.props.columnConfig}
                                        defaultDropColumns={defaultDropColumns}
                                        treeConfig={
                                            dropDownTitleConfig
                                                ? customColumnConfig
                                                : this.props.treeConfig
                                        }
                                        type={type}
                                        showClassification={
                                            this.props.showClassification
                                        }
                                        queryGridUrl={queryGridUrl}
                                        queryTreeUrl={queryTreeUrl}
                                        hasAddButton={hasAddButton}
                                        addButtonList={addButtonList}
                                        addButtonDropDown={addButtonDropDown}
                                        searchDataSize={searchDataSize}
                                        isAddButtonShow={isAddButtonShow}
                                        onFocus={onFocus}
                                        getCommonColumns={this.getCommonColumns}
                                        getDisplayOrValue={
                                            this.getDisplayOrValue
                                        }
                                        toggleValueForMapOrObject={
                                            this.toggleValueForMapOrObject
                                        }
                                        stopPropagationWhenDropdownPressEnter={
                                            stopPropagationWhenDropdownPressEnter
                                        }
                                        showDropDownTable={showDropDownTable}
                                        onHotKeyClose={this.onHotKeyClose}
                                        funColumnNum={this.funColumnNum}
                                        setStorage={this.setStorage}
                                        fieldValued={fieldValued}
                                        refType={refType}
                                        collectUsualData={collectUsualData}
                                        beforeEvent={this.beforeEvent}
                                        show={this.show}
                                        checkUsual={this.checkUsual}
                                        isShowUsual={isShowUsual}
                                        checkAddButtons={this.checkAddButtons}
                                        handleHideDropTable={
                                            this.handleHideDropTable
                                        }
                                        handleOnlyHideDropTable={
                                            this.handleOnlyHideDropTable
                                        }
                                        handleTimerVlaue={timer => {
                                            this.timerDrop = timer;
                                        }}
                                        referInput={this.referInput}
                                        loadHistoryData={this.loadHistoryData}
                                        renderColumnConfig={
                                            this.renderColumnConfig
                                        }
                                        showCodeIfPossible={
                                            this.showCodeIfPossible
                                        }
                                        handleLoadUsual={this.handleLoadUsual}
                                        onRef={node => (this.Child = node)}
                                        renderInTable={this.props.renderInTable}
                                        usualCollectAction={
                                            this.usualCollectAction
                                        }
                                        updateSelectedValue={updateSelectedValues => {
                                            this.setState({
                                                selectedValues:
                                                    updateSelectedValues,
                                            });
                                        }}
                                        updateTableData={updateTableData => {
                                            this.setState({ tableData: updateTableData });
                                        }}
                                        updateReferVal={updateReferVal => {
                                            this.setState({ referVal: updateReferVal });
                                        }}
                                        updateDropTabsKey={updateDropTabsKey => {
                                            this.updateDropTabsActiveKey(
                                                updateDropTabsKey,
                                            );
                                        }}
                                        updateShowHistory={updateShowHistory => {
                                            this.setState({
                                                showHistoryFlag:
                                                    updateShowHistory,
                                            });
                                        }}
                                        upadteAddButtonShow={updateAddButtonShow => {
                                            this.setState({
                                                isAddButtonShow:
                                                    updateAddButtonShow,
                                            });
                                        }}
                                        updateColumnConfigPop={() => {
                                            this.updateShowColumnConfigPop();
                                        }}
                                        useSingleSelect={item => {
                                            this.singleSelect(item);
                                        }}
                                        useMultiSelect={() => {
                                            this.multiSelect();
                                        }}
                                        title={title}
                                        // onEnter 回调 bbqin
                                        onEnter={onEnter}
                                        isMultiSelectedEnabled={
                                            isMultiSelectedEnabled
                                        }
                                        width={
                                            this.referContainer &&
                                            this.referContainer.offsetWidth

                                            // this.refer && this.refer.offsetWidth
                                        }
                                        searchKey={referVal}
                                        isLabelDesign={this.props.isLabelDesign}
                                        onSureBtnClick={
                                            this.props.onSureBtnClick
                                        }
                                        dropDownTitleConfig={
                                            dropDownTitleConfig
                                        }
                                    />
                                }

                                {/* {this.renderDropDownTable()} */}
                            </React.Fragment>
                        );
                    })()}
                    getPopupContainer={() =>
                        typeof dropDownContainer === 'function'
                            ? dropDownContainer()
                            : dropDownContainer
                    }

                >
                    {clickContainer ? (
                        cloneElement(clickContainer, {
                            onClick: event => {
                                //适配岳鹏
                                if (this.props.pageTemplate) {
                                    if (clickContainer.props.onClick()) {
                                        return;
                                    }
                                } else {
                                    this.run(
                                        clickContainer.props.onClick,
                                        event,
                                    );
                                }
                                this.beforeEvent(onFocus, this.show, event);
                            },
                            className: ' refer-click-container',
                        })
                    ) : (
                        <Col
                            xs={12}
                            className={`refer clearfix ${referClassName} ${
                                hasClearButton && 'has-clear-button'
                            } ${perceptionInputContainerClass(
                                disabled,
                                this.focusFlag,
                            )}`}
                            style={{ ...style }}
                            onClick={event => {
                                if (event.target.matches('.icon-qingkong')) {
                                    return;
                                }
                                this.referInput && this.referInput.focus();
                            }}
                        >
                            <div>
                                <ul
                                    onClick={() => {
                                        this.referInput?.focus();
                                    }}
                                >
                                    {/* <TagGroup 
	                                    onFocus={this.handleInput} 
	                                    isMultiSelectedEnabled={isMultiSelectedEnabled} 
	                                    onChange={this.handleInput} 
	                                    onBlur={this.close}
	                                    disabled={!!disabled}
	                                /> */}
                                    <li
                                        style={{
                                            display:
                                                !isFocusStatus &&
                                                isMultiSelectedEnabled &&
                                                trueValue.length
                                                    ? 'grid'
                                                    : 'none',
                                        }}
                                        className={`selected-item single-select`}
                                        onClick={event => {
                                            // this.referInput &&
                                            //     this.referInput.focus();
                                            if(this.props.refReadOnly){
                                                setTimeout(() => {
                                                    this.beforeEvent(
                                                        onFocus,
                                                        this.show,
                                                        event,
                                                        { fromIconRefer: true },
                                                    );
                                                }, 302);
                                                return;
                                            }
                                            this.beforeEvent(
                                                onFocus,
                                                () => {
                                                    this.handleInputClick();
                                                },
                                                event,
                                            );
                                        }}
                                    >
                                        {showTitle ? (
                                            <TipsTitle
                                                title={allLabel}
                                            ></TipsTitle>
                                        ) : (
                                            <span>{allLabel}</span>
                                        )}
                                    </li>
                                    {/* {!isEdit && trueValue.length > 1 ? (
	                                    <li className="selected-num" >
											+{trueValue.length - 1}
	                                    </li>
	                                ) : null} */}
                                    {/* 多选状态下，input focus时展示的li,即输入框内显示值 */}
                                    <li
                                        className={`selected-input ${
                                            !isFocusStatus &&
                                            isMultiSelectedEnabled &&
                                            trueValue.length > 0
                                                ? 'selected-input-hidden'
                                                : ''
                                        }`}
                                    >
                                        <InputElement
                                            readOnly={this.props.refReadOnly ? true : false}
                                            ref={dom => {
                                                this.referInput =
                                                    ReactDOM.findDOMNode(dom);
                                                this.referInput =
                                                    this.referInput &&
                                                    this.referInput.querySelector(
                                                        inputSelector,
                                                    );
                                            }}
                                            rows="1"
                                            autoHeight={autoHeight} // textarea时
                                            canResize={false}
                                            wrapperClassName={`refer-input ${className}`}
                                            className="refer-input"
                                            fieldid={getSysFieldid(
                                                'refer-input',
                                            )}
                                            disabled={!!disabled}
                                            value={referVal || ''}
                                            onClick={event => {
                                                // if (this.abandTouch) {
                                                //     return;
                                                // }
                                                if(this.props.refReadOnly){
                                                    this.setState(
                                                        { showDropDownTable: false },
                                                        () => {
                                                            setTimeout(() => {
                                                                this.setState({
                                                                    tableData: [
                                                                        {
                                                                            rows: [],
                                                                            page: usePagaPageInfo
                                                                                ? pagPageInfo
                                                                                : tableData[0]
                                                                                    .page || {
                                                                                    pageIndex: 0,
                                                                                    totalPage: 1,
                                                                                },
                                                                        },
                                                                    ],
                                                                });
                                                                this.beforeEvent(
                                                                    onFocus,
                                                                    this.show,
                                                                    event,
                                                                    { fromIconRefer: true },
                                                                );
                                                            }, 302);
                                                        },
                                                    );
                                                    return;
                                                }

                                                this.beforeEvent(
                                                    onFocus,
                                                    () => {
                                                        this.handleInputClick();
                                                    },
                                                    event,
                                                );

                                                // event.stopPropagation();
                                                event.target.focus();
                                                typeof onClick === 'function' &&
                                                    onClick(event);
                                                let ncc_automated =
                                                    getGlobalStorage(
                                                        'localStorage',
                                                        '_ncc_automated_',
                                                    );
                                                if (ncc_automated == '1') {
                                                    // 自动化测试开关打开
                                                    this.handleInput(
                                                        event.target.value,
                                                        { searchNow: true },
                                                    );
                                                }
                                            }}
                                            onChange={value => {
                                                let ncc_automated =
                                                    getGlobalStorage(
                                                        'localStorage',
                                                        '_ncc_automated_',
                                                    );
                                                // 自动化测试开关关闭
                                                this.handleInput(value, {
                                                    searchNow: true,
                                                    // ncc_automated != '1',
                                                });
                                            }}
                                            // onEnter 回调 bbqin
                                            onEnter={({ e }) => {
                                                console.log(11111111111111);
                                                // 处理掉一部分  状态不显示情况触发不了onEnter  state.dropDownShow 并不能作为下拉的状态判断
                                                let noShow =
                                                        !(
                                                            isHistoryStatus ||
                                                            isSearchStatus ||
                                                            isSelectedStatus
                                                        ) ||
                                                        !this.state
                                                            .dropDownShow,
                                                    target = e.target;

                                                let timer = setTimeout(() => {
                                                    this.hotKeyClose = false;
                                                    // 弹窗如果没有关闭阻止  onEnter 跳转
                                                    !this.state.isShow &&
                                                        noShow &&
                                                        onEnter &&
                                                        onEnter({
                                                            e,
                                                            target,
                                                            eventKey: 'Enter',
                                                        });
                                                    clearTimeout(timer);
                                                }, 20);
                                            }}
                                            hotKeyWithArrow={({ e }) => {
                                                let { historySelectionVisible } = this.state;
                                                let status = {
                                                    isHistoryStatus,
                                                    isSearchStatus,
                                                    isSelectedStatus,
                                                    historySelectionVisible,
                                                };
                                                handleArrowKeyDown({
                                                    context: this,
                                                    callBack: hotKeyWithArrow,
                                                    e,
                                                    status,
                                                });
                                            }}
                                            onMouseDown={() => {
                                                this.referInputMouseDown = true;
                                            }}
                                            onFocus={event => {
                                                if(this.props.refReadOnly){
                                                    return;
                                                }
                                                if (
                                                    this.state.isShow ||
                                                    disabled
                                                ) {
                                                    // isShow兼容DropDownRefer
                                                    return false;
                                                }
                                                let {
                                                    showCodeWhenFocus,
                                                    fieldValued,
                                                    focusSelect = true,
                                                } = this.props;
                                                let trueValue = [
                                                    ...this.getSelections().values(),
                                                ];
                                                let input = event.target,
                                                    referInputMouseDown =
                                                        this
                                                            .referInputMouseDown;
                                                if (
                                                    showCodeWhenFocus &&
                                                    fieldValued === 'refpk' &&
                                                    trueValue.length &&
                                                    this.props.refName !==
                                                        '技术参数类型'
                                                ) {
                                                    // 查已选数据，显示编码
                                                    // 没有code的时候才查
                                                    // if (trueValue.some(e => !e.refcode)) {
                                                    let result =
                                                        this.loadSelectedData(
                                                            trueValue,
                                                            { shouldUpdate: false },
                                                        );
                                                    if (result.length) {
                                                        trueValue = result;
                                                        let selectedValues =
                                                            new Map(
                                                                result.map(
                                                                    e => [
                                                                        e[
                                                                            idKey
                                                                        ],
                                                                        e,
                                                                    ],
                                                                ),
                                                            );
                                                        // TODO:保证willReceiveProps里拿到的是新的，待优化
                                                        this.state.selectedValues =
                                                            selectedValues;

                                                        let newTableDate = [
                                                            {
                                                                rows: [
                                                                    ...selectedValues.values(),
                                                                ],
                                                                page: usePagaPageInfo
                                                                    ? pagPageInfo
                                                                    : tableData[0]
                                                                        .page || {
                                                                        pageIndex: 0,
                                                                        totalPage: 1,
                                                                    },
                                                            },
                                                        ];
                                                        this.setState({
                                                            selectedValues,
                                                            tableData:
                                                                newTableDate,
                                                        });
                                                    }
                                                    // }
                                                    let referVal =
                                                        this.getDisplayOrValue(
                                                            trueValue,
                                                            'refcode',
                                                        ) ||
                                                        this.getDisplayOrValue(
                                                            trueValue,
                                                            'display',
                                                        );

                                                    this.setState(
                                                        { referVal },
                                                        () => {
                                                            if(focusSelect){
                                                                input.setSelectionRange(
                                                                    0,
                                                                    referVal.length,
                                                                );
                                                            }
                                                           
                                                        },
                                                    );
                                                } else {
                                                    //树参照情况下且没有用接口去查已选数据且下拉面板又需要表格数据时
                                                    //通过trueValue去更新tableData,注意这里也可以用selectedValues去更新tableData
                                                    // if (
                                                    //     fieldValued ===
                                                    //         'refpk' &&
                                                    //     trueValue.length &&
                                                    //     refType === 'tree'
                                                    // ) {
                                                    //     let selectedValues =
                                                    //         new Map(
                                                    //             trueValue.map(
                                                    //                 (e) => [
                                                    //                     e[
                                                    //                         idKey
                                                    //                     ],
                                                    //                     e,
                                                    //                 ]
                                                    //             )
                                                    //         );
                                                    //     // TODO:保证willReceiveProps里拿到的是新的，待优化
                                                    //     this.state.selectedValues =
                                                    //         selectedValues;

                                                    //     let newTableDate = [
                                                    //         {
                                                    //             rows: [
                                                    //                 ...selectedValues.values(),
                                                    //             ],
                                                    //             page: this.state
                                                    //                 .tableData[0]
                                                    //                 .page || {
                                                    //                 pageIndex: 0,
                                                    //                 totalPage: 1,
                                                    //             },
                                                    //         },
                                                    //     ];
                                                    //     this.setState({
                                                    //         selectedValues,
                                                    //         tableData:
                                                    //             newTableDate,
                                                    //     });
                                                    // }
                                                    if(focusSelect){
                                                        input.setSelectionRange(
                                                            0,
                                                            referVal.length,
                                                        );
                                                    }   
                                                }

                                                if (this.focusFromPopoverBlur) {
                                                    this.focusFromPopoverBlur = false;
                                                } else {
                                                    this.beforeEvent(
                                                        onFocus,
                                                        (...rest) => {
                                                            if (
                                                                this.autoFocus
                                                            ) {
                                                                // autoFocus时延迟执行，否则this.referInput为空导致handleInput提前return
                                                                setTimeout(
                                                                    () => {
                                                                        this.handleFocus(
                                                                            ...rest,
                                                                        );
                                                                    },
                                                                    0,
                                                                );
                                                            } else {
                                                                this.handleFocus(
                                                                    ...rest,
                                                                );
                                                            }
                                                        },
                                                        event,
                                                        { fromFocus: true },
                                                    );
                                                }
                                            }}
                                            onMouseUp={() => {
                                                this.referInputMouseDown = false;
                                            }}
                                            placeholder={
                                                (this.state.isShow
                                                    ? [
                                                        ...(
                                                            this._value ||
                                                              new Map()
                                                        ).values(),
                                                    ]
                                                    : this.getSelections()
                                                ).length
                                                    ? ''
                                                    : placeholder
                                            }
                                            autoFocus={this.autoFocus}
                                            tabIndex={tabskip ? '-1' : tabIndex}
                                            onBlur={this.close}
                                            //maxlength={1000}
                                            // maxLength={finalMaxLength}
                                            renderInTable={
                                                this.props.renderInTable
                                            }
                                            onKeyDown={e => {
                                                console.log(22222222222222);
                                                let status = this.getStatus();
                                                this.props.onKeyDown({
                                                    e,
                                                    status,
                                                });
                                                if (
                                                    status.isSearchStatus &&
                                                    (e.keyCode === 38 ||
                                                        e.keyCode === 40)
                                                ) {
                                                    // 禁用上下键防止光标跳动
                                                    e.preventDefault();
                                                }
                                                if (e.keyCode === 188) {
                                                    // 逗号
                                                }
                                            }}
                                            itemtype="refer"
                                            // NCC-154592 参照英文验证
                                            spellcheck="false"
                                            onPaste={event => {
                                                // // 表格中会影响默认的粘贴事件 去除
                                                // if (this.props.renderInTable) {
                                                //     return;
                                                // }
                                                if (disabled) {
                                                    return;
                                                }
                                                event.preventDefault();
                                                let paste = (
                                                    event.clipboardData ||
                                                    window.clipboardData
                                                ).getData('text');
                                                paste = paste.replace(
                                                    /\r|^\s*|\s*$/g,
                                                    '',
                                                );
                                                this.handlePaste(
                                                    paste.replace(/\n/g, ',') ??
                                                        '',
                                                );
                                                if (isMultiSelectedEnabled) {
                                                    // 多选换行改逗号
                                                    paste =
                                                        paste.replace(
                                                            /\n/g,
                                                            ',',
                                                        ) ?? '';
                                                } else {
                                                    // 单选取第一行（配合表格粘贴）
                                                    paste =
                                                        paste.split(
                                                            /[\n]/g,
                                                        )[0] ?? '';
                                                }
                                                let ncc_automated =
                                                    getGlobalStorage(
                                                        'localStorage',
                                                        '_ncc_automated_',
                                                    );
                                                // 自动化测试开关关闭
                                                let selectionStart =
                                                    event.target.selectionStart;
                                                let selectionEnd =
                                                    event.target.selectionEnd;
                                                let newCursorPosition = selectionStart + paste.length;
                                                paste =
                                                    referVal.slice(
                                                        0,
                                                        selectionStart,
                                                    ) +
                                                    paste +
                                                    referVal.slice(
                                                        selectionEnd,
                                                    );
                                                // paste = paste.slice(0, 1000);
                                                // 粘贴前清空一下缓存数据  不能情况，会有问题
                                                // this._value = new Map();
                                                let inputElement = event.target;
                                                const setCursorPosition = () => {
                                                   inputElement.setSelectionRange(newCursorPosition, newCursorPosition);
                                                };
                                                this.handleInput(paste, {
                                                    searchNow:
                                                        ncc_automated != '1',
                                                    callback: setCursorPosition,
                                                });
                                            }}
                                        />
                                        <input
                                            // 用于复制
                                            type="text"
                                            ref={dom => {
                                                this.hiddenInput = dom;
                                            }}
                                            value={allLabel}
                                            readOnly
                                            className="hidden-input"
                                            tabIndex="-1"
                                        />
                                    </li>
                                </ul>
                            </div>
                            {hasClearButton && (
                                <i
                                    className={
                                        'refer-del-i iconfont icon-qingkong' +
                                        (disabled ? ' icon-hidden' : '')
                                    }
                                    onClick={event => {
                                        // event.stopPropagation();
                                        // this.referInput?.focus();
                                        // this.handleInputClick();
                                        // this.handleFocus();
                                        if (disabled) {
                                            return false;
                                        }

                                        typeof onClick === 'function' &&
                                            onClick(event);
                                        this.beforeEvent(
                                            onFocus,
                                            this.clear,
                                            event,
                                        );

                                        // if (
                                        //     !disabled &&
                                        //     this.props.fieldid === 'taskRefer'
                                        // ) {
                                        //     setTimeout(() => {
                                        //         this.setState({
                                        //             referVal: '',
                                        //             showHistoryFlag: true,
                                        //             selectedValues: new Map(),
                                        //         });
                                        //     }, 31);
                                        // }
                                    }}
                                    onMouseDown={e => {
                                        // 这里阻止本组件获取焦点的同时也会阻止其他组件失焦，故让activeElement失焦
                                        if (
                                            !this.refer.contains(
                                                document.activeElement,
                                            )
                                        ) {
                                            document.activeElement.blur();
                                        }
                                        // this.referInput?.focus();
                                        // this.referContainer?.focus();
                                        this.refer.focus();

                                        e.preventDefault();
                                    }}
                                />
                            )}
                            <span
                                className="icon-refer"
                                style={{
                                    cursor: disabled
                                        ? 'not-allowed'
                                        : 'pointer',
                                }}
                                // fieldid={getSysFieldid('icon-refer')}
                                onMouseDown={e => {
                                    // 这里阻止本组件获取焦点的同时也会阻止其他组件失焦，故让activeElement失焦
                                    if (
                                        !this.refer.contains(
                                            document.activeElement,
                                        )
                                    ) {
                                        document.activeElement.blur();
                                    }
                                    this.abandTouch = true;
                                    e.preventDefault();
                                }}
                                onClick={event => {
                                    // event.stopPropagation();
                                    typeof onClick === 'function' && onClick(event);
                                    if (showDropDownTable && isMultiSelectedEnabled) {
                                        // 如果下拉显示，且还是多选，有可能已操作过数据
                                        this.multiSelect();
                                    }
                                    // this.setState({
                                    //     hiddenDrop: true,
                                    // });

                                    if (isShowUsual) {
                                        this.loadUsualData(false).then(
                                            data => {
                                                // 有常用--更新下拉面板常用数据
                                                data.rows.forEach(e => {
                                                    collectUsualData.set(
                                                        e.refpk,
                                                        e,
                                                    );
                                                });

                                                if (showDropDownTable) {
                                                    if (
                                                        type === 'dropDown' &&
                                                        refType === 'grid'
                                                    ) {
                                                        console.log('下拉参照');
                                                    } else {
                                                        //切换为新下拉面板时注意添加该逻辑
                                                        // setTimeout(() => {
                                                        //     //关闭弹窗再次打开的时候，滚动条位置回正
                                                        //     if (
                                                        //         type === 'dropDown' &&
                                                        //         refType === 'grid'
                                                        //     ) {
                                                        //         console.log('下拉参照');
                                                        //     } else {
                                                        //         let referdroptable =
                                                        //             'refer-drop-' +
                                                        //             this.props.attrcode;
                                                        //         let element =
                                                        //             document.getElementsByClassName(
                                                        //                 referdroptable
                                                        //             )[0];
                                                        //         if (element) {
                                                        //             let flexRight =
                                                        //                 element.querySelector(
                                                        //                     '.wui-table-fixed-right'
                                                        //                 );
                                                        //             let tableBodyInnerScroll =
                                                        //                 flexRight.querySelector(
                                                        //                     '.wui-table-body-inner'
                                                        //                 );
                                                        //             tableBodyInnerScroll.scrollTop = 0;
                                                        //         }
                                                        //     }
                                                        // }, 500);
                                                        // this.updateDropTabsActiveKey(
                                                        //     this.getDropActiveKey()
                                                        // );
                                                    }
                                                    // this.setState({
                                                    //     cancelSearchStatus: true,
                                                    // });
                                                }

                                                this.setState(
                                                    {
                                                        showDropDownTable: false,
                                                        collectUsualData,
                                                        isSelectedShow: false,
                                                    },
                                                    () => {
                                                        // 查全部数据
                                                        // if (
                                                        //     type === 'dropDown' &&
                                                        //     refType === 'grid'
                                                        // ) {
                                                        //     console.log('下拉参照');
                                                        // } else {
                                                        //     this.close();
                                                        // }

                                                        setTimeout(() => {
                                                            this.setState({
                                                                tableData: [
                                                                    {
                                                                        rows: [],
                                                                        page: usePagaPageInfo
                                                                            ? pagPageInfo
                                                                            : tableData[0]
                                                                                .page || {
                                                                                pageIndex: 0,
                                                                                totalPage: 1,
                                                                            },
                                                                    },
                                                                ],
                                                            });
                                                            this.beforeEvent(
                                                                onFocus,
                                                                this.show,
                                                                event,
                                                                { fromIconRefer: true },
                                                            );
                                                            if (
                                                                this.Child &&
                                                                this.Child
                                                                    .dropscrolltable &&
                                                                this.Child
                                                                    .dropscrolltable
                                                                    .scrollLeft >
                                                                    0
                                                            ) {
                                                                this.Child.dropscrolltable.scrollLeft = 0;
                                                            }
                                                        }, 302);
                                                    },
                                                );
                                            },
                                        );
                                    } else {
                                        if (showDropDownTable) {
                                            if (
                                                type === 'dropDown' &&
                                                refType === 'grid'
                                            ) {
                                                console.log('下拉参照');
                                            } else {
                                                //切换为新下拉面板时注意添加该逻辑
                                                // setTimeout(() => {
                                                //     //关闭弹窗再次打开的时候，滚动条位置回正
                                                //     if (
                                                //         type === 'dropDown' &&
                                                //         refType === 'grid'
                                                //     ) {
                                                //         console.log('下拉参照');
                                                //     } else {
                                                //         let referdroptable =
                                                //             'refer-drop-' +
                                                //             this.props.attrcode;
                                                //         let element =
                                                //             document.getElementsByClassName(
                                                //                 referdroptable
                                                //             )[0];
                                                //         if (element) {
                                                //             let flexRight =
                                                //                 element.querySelector(
                                                //                     '.wui-table-fixed-right'
                                                //                 );
                                                //             let tableBodyInnerScroll =
                                                //                 flexRight.querySelector(
                                                //                     '.wui-table-body-inner'
                                                //                 );
                                                //             tableBodyInnerScroll.scrollTop = 0;
                                                //         }
                                                //     }
                                                // }, 500);
                                                // this.updateDropTabsActiveKey(
                                                //     this.getDropActiveKey()
                                                // );
                                            }
                                            // this.setState({
                                            //     cancelSearchStatus: true,
                                            // });
                                        }

                                        this.setState(
                                            { showDropDownTable: false },
                                            () => {
                                                // 查全部数据
                                                // if (
                                                //     type === 'dropDown' &&
                                                //     refType === 'grid'
                                                // ) {
                                                //     console.log('下拉参照');
                                                // } else {
                                                //     this.close();
                                                // }

                                                setTimeout(() => {
                                                    this.setState({
                                                        tableData: [
                                                            {
                                                                rows: [],
                                                                page: usePagaPageInfo
                                                                    ? pagPageInfo
                                                                    : tableData[0]
                                                                        .page || {
                                                                        pageIndex: 0,
                                                                        totalPage: 1,
                                                                    },
                                                            },
                                                        ],
                                                    });
                                                    this.beforeEvent(
                                                        onFocus,
                                                        this.show,
                                                        event,
                                                        { fromIconRefer: true },
                                                    );
                                                    if (
                                                        this.Child &&
                                                        this.Child
                                                            .dropscrolltable &&
                                                        this.Child
                                                            .dropscrolltable
                                                            .scrollLeft > 0
                                                    ) {
                                                        this.Child.dropscrolltable.scrollLeft = 0;
                                                    }
                                                }, 302);
                                            },
                                        );

                                        this.setState({ isSelectedShow: false });
                                    }
                                }}
                            />
                        </Col>
                    )}
                </Dropdown>
                {Array.isArray(functions) && functions.length ? (
                    <Dropdown
                        trigger={['click']}
                        overlayClassName={
                            getSysFieldid('fieldid_function_refer')
                                ? 'fieldid_function_refer refer-function-dropdown'
                                : 'refer-function-dropdown'
                        }
                        getPopupContainer={() =>
                            typeof dropDownFxContainer === 'function'
                                ? dropDownFxContainer()
                                : dropDownFxContainer
                        }

                        placement="bottomLeft"
                        overlay={
                            <ul>
                                {functions.map(e => (
                                    <li
                                        key={e.name}
                                        onClick={this.onFunctionClick.bind(
                                            this,
                                            e,
                                        )}
                                    >
                                        {e.name}
                                    </li>
                                ))}
                            </ul>
                        }
                        overlayStyle={{ display: disabled && 'none' }}
                    >
                        <span
                            className={`refer-function ${
                                disabled
                                    ? 'refer-function-disabled'
                                    : 'refer-function-common'
                            }`}
                            onClick={onClick}
                        >
                            fx
                        </span>
                    </Dropdown>
                ) : null}
                {this.renderDropDown()}
                {this.renderPopover()}
            </div>
        );
    }
}

BaseRefer.propTypes = {
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]), // 参照的值
    foolValue: PropTypes.object, // {display, value}的值
    onChange: PropTypes.func, // onChange事件
    onCancel: PropTypes.func, // onCancel事件
    extraOnChange: PropTypes.func, // 额外的onChange事件——sunzg
    refName: PropTypes.string, // 参照名称
    refName_db: PropTypes.string, // 后台参照名称——wpz
    refType: PropTypes.oneOf(['tree', 'grid', 'gridTree']), // 参照类型
    type: PropTypes.oneOf(['dropDown', 'popover']), // 参照展示类型
    columnConfig: PropTypes.array, // 列信息配置
    treeConfig: PropTypes.object, // 树信息配置
    hotDataSize: PropTypes.number, // 历史记录条数
    searchDataSize: PropTypes.number, // 搜索结果条数
    pageSize: PropTypes.number, // 分页请求数据时每页条数
    disabled: PropTypes.bool, // 是否禁用
    referClassName: PropTypes.string, // 参照最外层classname
    className: PropTypes.string, // 参照input的classname
    style: PropTypes.object, // 参照最外层样式
    placeholder: PropTypes.string, // 占位文字
    showHistory: PropTypes.bool, // 是否显示历史记录
    queryGridUrl: PropTypes.string, // 查询表格数据的url
    queryTreeUrl: PropTypes.string, // 查询树数据的url
    clickContainer: PropTypes.object, // 可以触发参照弹窗事件的容器
    queryCondition: PropTypes.oneOfType([PropTypes.func, PropTypes.object]), // 自定义查询条件，会传到后台
    isCacheable: PropTypes.bool, // 是否启用数据缓存
    container: PropTypes.object, // 容器
    dropDownContainer: PropTypes.oneOfType([PropTypes.func, PropTypes.object]), // 下拉的容器
    dropDownFxContainer: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.object,
    ]), // 下拉的容器

    isMultiSelectedEnabled: PropTypes.bool, // 是否多选
    onTreeNodeExpand: PropTypes.func, // 树节点展开事件
    maxCacheNum: PropTypes.number, // 缓存条数
    rootNode: PropTypes.object, // 树的根节点
    autoFocus: PropTypes.bool, // 自动获取焦点
    onBlur: PropTypes.func, // 失去焦点事件
    onFocus: PropTypes.func, // 获取焦点事件
    onlyLeafCanSelect: PropTypes.bool, // 是否只有树节点可选
    isTreelazyLoad: PropTypes.bool, // 树是否懒加载
    allowSearchConfig: PropTypes.bool, // 是否启用搜索设置
    allowColumnConfig: PropTypes.bool, // 是否启用列设置
    fieldDisplayed: PropTypes.string, // 作为display的字段
    fieldValued: PropTypes.string, // 作为value的字段
    isShowDisabledData: PropTypes.bool, // 显示停用
    isHasDisabledData: PropTypes.bool, // 是否有【显示停用】功能
    unitProps: PropTypes.object, // 业务单元参照的属性
    unitCondition: PropTypes.oneOfType([PropTypes.func, PropTypes.object]), // 业务单元参照的过滤条件
    isShowUnit: PropTypes.bool, // 业务单元参照的属性
    checkStrictly: PropTypes.bool, // 检验值的准确性（必须是后台有的值）
    popWindowClassName: PropTypes.string, // 添加到弹出层的class
    idKey: PropTypes.string, // 树id对应的key值
    pidKey: PropTypes.string, // 树pid对应的key值
    rowKey: PropTypes.string, // 表格的rowKey值
    isShowUsual: PropTypes.bool, // 是否显示常用
    defaultUnitValue: PropTypes.object, // 业务单元默认值
    isShowTableSearch: PropTypes.bool, // 显示表格区的搜索框
    isShowTreeSearch: PropTypes.bool, // 显示树区的搜索框
    isShowSelectedBtn: PropTypes.bool, // 显示已选按钮
    functions: PropTypes.array, // 参照函数
    showTitle: PropTypes.bool, // 鼠标悬停是否显示title
    isRunWithChildren: PropTypes.bool, // 是否启用【执行时包含下级】功能
    isAlwaysEmitOnChange: PropTypes.bool, // 是否始终触发编辑后事件
    unitValueIsNeeded: PropTypes.bool, // 只有选业务单元才会发请求
    tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tabskip: PropTypes.bool, // tab键跳过
    baseTabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // tabIndex基于此值往上加
    inputDefer: PropTypes.number, // 输入后触发事件的延迟时间
    onClick: PropTypes.func,
    needFocusOnClose: PropTypes.bool, // 关闭后是否需要获取焦点
    dropDownPlacement: PropTypes.string, // 关闭后是否需要获取焦点
    dropDownTitleConfig: PropTypes.object, // 关闭后是否需要获取焦点
    maxChoice: PropTypes.number, // 最多选择的数据条数
    zIndex: PropTypes.number, //
    async: PropTypes.bool, // 请求是否异步
    searchWithKeywordOutsideWhenOpen: PropTypes.bool, // 打开界面时根据外部输入框的搜索关键字进行搜索结果的展示
    selectFirstTreeNodeWhenOpen: PropTypes.bool, // 树表参照打开时是否选中第一个树节点并查右表
    queryCommonUseWhenOpen: PropTypes.bool, // 打开时是否查常用
    fieldSplitSep: PropTypes.string, // 多字段显示时，用来分割的分隔符，适用于fieldDisplayed和fieldValued
    fieldJoinSep: PropTypes.string, // 多字段显示时，用来连接的分隔符，适用于display和value
    usualDataSize: PropTypes.number, // 常用数据最大条数
    onKeyDown: PropTypes.func, // 键盘事件
    isQuerySelectedData: PropTypes.bool, // 点已选时是否走后台查询已选数据
    needQuerySelectedDataBeforeOnChange: PropTypes.bool, // 触发onChange之前是否走后台查询已选数据
    isShowSelected: PropTypes.bool, // 是否显示已选下拉
    isShowSearch: PropTypes.bool, // 是否显示搜索下拉
    defaultIncludeChildren: PropTypes.bool, // 默认勾选【包含下级】
    defaultRunWithChildren: PropTypes.bool, // 默认勾选【执行时包含下级】
    isShowIncludeChildren: PropTypes.bool, // 显示【包含全部】
    isShowIncludeSon: PropTypes.bool, // 显示【包含直接下级】
    extraParam: PropTypes.oneOfType([PropTypes.object, PropTypes.func]), // 发请求时的额外参数
    hasAddButton: PropTypes.bool, // 是否有新增按钮
    addButtons: PropTypes.array, // 新增按钮列表
    scrollSelectedNodeIntoView: PropTypes.bool, // 将选中的节点展示在视图中
    clearUnitValueWhenOpen: PropTypes.bool, // 打开参照时清空业务单元的值
    defaultMax: PropTypes.bool, // 默认最大化展示
    treeWidth: PropTypes.string, // 树表参照左树默认宽度
    expandAllNodeWhenFirstOpen: PropTypes.bool, // 属性参照默认展开全部
    isBlurSearch: PropTypes.bool, // 失去焦点时搜索
    inputSearch: PropTypes.bool, // 输入框搜索时是否触发搜索
    selectRootNodeWhenGridTreeReferSearch: PropTypes.bool, // 树表参照搜索时是否选择根节点
    useLoading: PropTypes.bool, // 发起请求时是否有loading
    pageSizeOptions: PropTypes.array, // 表格分页可以选每页大小配置
    showCodeWhenFocus: PropTypes.bool, // 参照获取焦点时显示编码
    dropdownClassName: PropTypes.string, // 参照下拉className
    searchTrigger: PropTypes.string, // 触发弹窗内搜索的事件
    showClassification: PropTypes.bool, // 是否显示所属分类
    rootNodeSelectable: PropTypes.bool, // 根节点是否可点击
    disabledDrag: PropTypes.bool, // 是否可拖拽
    inputType: PropTypes.string, // 输入框的元素类型
    filterOriginData: PropTypes.bool, //掌中宝
    isShowPrompt: PropTypes.bool, //控制下拉面板显隐，参照点击x且有弹窗时，隐藏下拉面板，传true
    // addButtonDropDown: PropTypes.array, // 新增按钮列表-下拉面板
    // unLazyLoadFilter: PropTypes.bool,
    pageTemplate: PropTypes.bool, //适配岳鹏
    abandGridSort: PropTypes.bool,
    useHistoryCache: PropTypes.bool,
    ignoreLeafDisable: PropTypes.bool,
    refValueTrim: PropTypes.bool, //输入框值去空格
    extraTreeData: PropTypes.array, //直接给参照传树数据
    // defaultDropColumns: PropTypes.array, //下拉面板中默认要显示的列
    defaultCheckedTreeNode: PropTypes.bool, //树表参照：勾选表格行时是否默认选中树节点
    focusSelect: PropTypes.bool, //获取焦点时是否全部选中文本
    showClearButton: PropTypes.bool, // 是否显示清除按钮
};

BaseRefer.defaultProps = {
    foolValue: null, // {display, value}格式的值
    refName: '', // 参照名称
    refName_db: '', // 后台参照名称
    refType: 'grid', // 参照类型
    type: 'popover', // 参照展示类型
    columnConfig: [
        {
            name: [
                '编码',
                // (jsonInsideRefer || {})['containers-refer-0038'],
                '名称',
                // (jsonInsideRefer || {})['containers-refer-0039']
            ],
            code: ['refcode', 'refname'],
        },
    ], // 列信息配置
    treeConfig: {
        // 名称
        name: [
            '名称',
            // (jsonInsideRefer || {})['containers-refer-0039']
        ],
        code: ['refname'],
    }, // 树信息配置
    hotDataSize: 10, // 历史记录条数
    searchDataSize: 100, // 搜索结果条数
    pageSize: 50, // 分页请求数据时每页条数
    disabled: false, // 是否禁用
    referClassName: '', // 参照最外层classname
    className: '', // 参照input的classname
    style: {}, // 参照最外层样式
    placeholder: '', // 占位文字
    showHistory: true, // 是否显示历史记录
    queryGridUrl: '', // 查询表格数据的url
    queryTreeUrl: '', // 查询树数据的url
    clickContainer: null, // 可以触发参照弹窗事件的容器
    queryCondition: null, // 自定义查询条件，会传到后台
    isCacheable: true, // 是否启用数据缓存
    container: document.body, // 容器
    dropDownContainer: document.body, // 容器
    dropDownFxContainer: document.body, // 容器
    isMultiSelectedEnabled: false, // 是否多选
    onTreeNodeExpand() {}, // 树节点展开事件
    maxCacheNum: 10, // 缓存条数
    // 根节点
    rootNode: { refname: '根节点', refpk: 'root' },
    autoFocus: false, // 自动获取焦点
    onBlur: null, // 失去焦点事件
    onFocus: null, // 获取焦点事件
    onlyLeafCanSelect: false, // 是否只有树节点可选
    isTreelazyLoad: false, // 树是否懒加载
    allowSearchConfig: true, // 是否启用搜索设置
    allowColumnConfig: true, // 是否启用列设置
    fieldDisplayed: 'refname', // 作为display的字段
    fieldValued: 'refpk', // 作为value的字段
    isShowDisabledData: false, // 显示停用
    isHasDisabledData: true, // 是否有【显示停用】功能
    unitProps: null, // 业务单元参照的属性
    isShowUnit: false, // 是否显示业务单元（前提是unitProps不为null）
    checkStrictly: true, // 检验值的准确性（必须是后台有的值）
    popWindowClassName: '', // 添加到弹出层的class
    idKey: 'refpk', // 树id对应的key值
    pidKey: 'pid', // 树pid对应的key值
    rowKey: 'refpk', // 表格的rowKey值
    isShowUsual: false, // 是否显示常用
    defaultUnitValue: {}, // 业务单元默认值
    isShowTableSearch: true, // 显示表格区的搜索框
    isShowTreeSearch: true, // 显示树区的搜索框
    isShowSelectedBtn: true, // 显示已选按钮
    functions: [], // 参照函数
    showTitle: true, // 鼠标悬停是否显示title
    isRunWithChildren: false, // 是否启用【执行时包含下级】功能
    isAlwaysEmitOnChange: false, // 是否始终触发编辑后事件
    unitValueIsNeeded: false, // 只有选业务单元才会发请求
    tabIndex: 0,
    tabskip: false, // tab键跳过
    baseTabIndex: 0, // tabIndex基于此值往上加
    inputDefer: 500, // 输入后触发事件的延迟时间
    onClick() {},
    needFocusOnClose: true, // 关闭后是否需要获取焦点
    dropDownPlacement: 'bottomLeft',
    dropDownTitleConfig: null,
    maxChoice: Infinity,
    async: true, // 请求是否异步,等待接口返回数据后再执行
    searchWithKeywordOutsideWhenOpen: true, // 打开界面时根据外部输入框的搜索关键字进行搜索结果的展示
    selectFirstTreeNodeWhenOpen: true, // 树表参照打开时是否选中第一个树节点并查右表
    queryCommonUseWhenOpen: true, // 打开时是否查常用
    fieldSplitSep: '/', // 多字段显示时，用来分割的分隔符，适用于fieldDisplayed和fieldValued
    fieldJoinSep: '/', // 多字段显示时，用来连接的分隔符，适用于display和value
    usualDataSize: 200, // 常用数据最大条数
    onKeyDown() {}, //input keyDown 事件
    isQuerySelectedData: true, // 点已选时是否走后台查询已选数据
    needQuerySelectedDataBeforeOnChange: false, // 触发onChange之前是否走后台查询已选数据
    isShowSelected: true, // 是否显示已选下拉
    isShowSearch: true, // 是否显示搜索下拉
    defaultIncludeChildren: false, // 默认勾选【包含下级】
    defaultRunWithChildren: false, // 默认勾选【执行时包含下级】
    isShowIncludeChildren: true, // 显示【包含全部】
    isShowIncludeSon: true, // 显示【包含直接下级】
    extraParam: {}, // 发请求时的额外参数
    hasAddButton: false, // 是否有新增按钮
    addButtons: [], // 新增按钮列表
    scrollSelectedNodeIntoView: true, // 将选中的节点展示在视图中
    clearUnitValueWhenOpen: false, // 打开参照时清空业务单元的值
    defaultMax: false, // 默认最大化展示
    treeWidth: '236px', // 树表参照左树默认宽度
    expandAllNodeWhenFirstOpen: false, // 属性参照默认展开全部
    isBlurSearch: true, // 失去焦点时搜索
    inputSearch: true, // 输入框搜索时是否触发搜索
    selectRootNodeWhenGridTreeReferSearch: true, // 树表参照搜索时是否选择根节点
    useLoading: false, // 发起请求时是否有loading
    pageSizeOptions: [50, 100, 200, 500], // 表格分页可以选每页大小配置
    showCodeWhenFocus: true, // 参照获取焦点时显示编码
    dropdownClassName: '', // 参照下拉className
    searchTrigger: 'input', // 触发弹窗内搜索的事件
    showClassification: true, // 是否显示所属分类
    rootNodeSelectable: false, // 根节点是否可点击
    inputType: 'input', // 输入框的元素类型
    disabledDrag: false, //禁止拖拽
    zIndex: 300,
    filterOriginData: false,
    isShowPrompt: false,
    // addButtonDropDown: [], //适配领域复写了新增按钮的逻辑，影响下拉面板的新增按钮
    // unLazyLoadFilter: false,
    pageTemplate: false, //适配岳鹏
    abandGridSort: false, //禁用参照表格排序功能
    useHistoryCache: true, //适配企业报表
    ignoreLeafDisable: false, //diabled叶子节点禁止点确定，适配道诚
    refValueTrim: false, //输入框值去空格
    extraTreeData: [], //直接给参照传树数据
    useExtraTreeData: false, //不使用接口返回树数据
    isDelayBlur: true, //适配刘辉表格摘要blur
    refReadOnly: false, //参照只读，点击的时候弹出
    // defaultDropColumns: ['refname', 'refcode'], //下拉面板中默认要显示的列
    defaultCheckedTreeNode: true, //树表参照：勾选表格行时是否默认选中树节点
    focusSelect: true, //获取焦点时是否全部选中文本
    showClearButton: true, // 是否显示清除按钮
};

export default BaseRefer;
